{
  "level": "courier",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:courier",
    "objects": "AREAS.E3:courier.e3",
    "mesh": "TREES.E3:courier.e3"
  },
  "spawn_point": {
    "position": [
      1159.1845461295663,
      1572.4381022192485,
      84.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1159.1845461295663,
      1672.4381022192485,
      84.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      500.0,
      520.0,
      60.0
    ],
    "bbox_max": [
      1884.1181640625,
      2800.0,
      210.0
    ],
    "vertex_count": 1426,
    "vertices": [
      [
        500.0,
        1690.0,
        78.0
      ],
      [
        500.0,
        1690.0,
        80.0
      ],
      [
        780.0,
        1690.0,
        80.0
      ],
      [
        780.0,
        1690.0,
        78.0
      ],
      [
        942.0,
        912.0,
        78.0
      ],
      [
        780.0,
        750.0,
        78.0
      ],
      [
        730.0,
        970.0,
        78.0
      ],
      [
        730.0,
        970.0,
        80.0
      ],
      [
        730.0,
        1120.0,
        78.0
      ],
      [
        730.0,
        1170.0,
        78.0
      ],
      [
        730.0,
        1400.0,
        78.0
      ],
      [
        730.0,
        700.0,
        78.0
      ],
      [
        730.0,
        700.0,
        80.0
      ],
      [
        730.0,
        930.0,
        80.0
      ],
      [
        730.0,
        930.0,
        78.0
      ],
      [
        730.0,
        1450.0,
        78.0
      ],
      [
        730.0,
        1690.0,
        78.0
      ],
      [
        500.0,
        1170.0,
        78.0
      ],
      [
        730.0,
        1170.0,
        78.0
      ],
      [
        500.0,
        1450.0,
        78.0
      ],
      [
        730.0,
        1450.0,
        78.0
      ],
      [
        730.0,
        1400.0,
        78.0
      ],
      [
        500.0,
        1400.0,
        78.0
      ],
      [
        504.0,
        1440.0,
        78.0
      ],
      [
        504.0,
        1450.0,
        78.0
      ],
      [
        500.0,
        970.0,
        78.0
      ],
      [
        500.0,
        970.0,
        80.0
      ],
      [
        730.0,
        970.0,
        80.0
      ],
      [
        730.0,
        970.0,
        78.0
      ],
      [
        500.0,
        1120.0,
        78.0
      ],
      [
        730.0,
        1120.0,
        78.0
      ],
      [
        730.0,
        930.0,
        78.0
      ],
      [
        730.0,
        930.0,
        80.0
      ],
      [
        500.0,
        930.0,
        80.0
      ],
      [
        500.0,
        930.0,
        78.0
      ],
      [
        780.0,
        1280.0,
        80.0
      ],
      [
        780.0,
        1280.0,
        78.0
      ],
      [
        960.0,
        1280.0,
        78.0
      ],
      [
        780.0,
        1170.0,
        80.0
      ],
      [
        780.0,
        1170.0,
        78.0
      ],
      [
        780.0,
        1280.0,
        78.0
      ],
      [
        780.0,
        1280.0,
        80.0
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        780.0,
        970.0,
        78.0
      ],
      [
        780.0,
        1120.0,
        78.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        750.0,
        78.0
      ],
      [
        780.0,
        930.0,
        78.0
      ],
      [
        780.0,
        930.0,
        80.0
      ],
      [
        780.0,
        930.0,
        80.0
      ],
      [
        780.0,
        930.0,
        78.0
      ],
      [
        942.0,
        930.0,
        78.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        1120.0,
        78.0
      ],
      [
        950.0,
        1120.0,
        78.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        970.0,
        78.0
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        941.9998779296875,
        970.0,
        78.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        942.0,
        970.0,
        78.0
      ],
      [
        942.0,
        930.0,
        78.0
      ],
      [
        905.0,
        1170.0,
        80.0
      ],
      [
        905.0,
        1170.0,
        78.0
      ],
      [
        780.0,
        1170.0,
        78.0
      ],
      [
        780.0,
        1170.0,
        80.0
      ],
      [
        905.0,
        1120.0,
        80.0
      ],
      [
        905.0,
        1120.0,
        78.0
      ],
      [
        905.0,
        1170.0,
        78.0
      ],
      [
        905.0,
        1170.0,
        80.0
      ],
      [
        891.0,
        1160.0,
        78.0
      ],
      [
        891.0,
        1170.0,
        78.0
      ],
      [
        893.1818237304688,
        1120.0,
        79.09090423583984
      ],
      [
        893.1818237304688,
        1130.0,
        79.09090423583984
      ],
      [
        891.6666870117188,
        1120.0,
        80.0
      ],
      [
        891.6666870117188,
        1130.0,
        80.0
      ],
      [
        960.0,
        1570.0,
        78.0
      ],
      [
        780.0,
        1570.0,
        78.0
      ],
      [
        780.0,
        1570.0,
        80.0
      ],
      [
        780.0,
        1690.0,
        78.0
      ],
      [
        780.0,
        1690.0,
        80.0
      ],
      [
        780.0,
        1570.0,
        80.0
      ],
      [
        780.0,
        1570.0,
        78.0
      ],
      [
        960.0,
        1450.0,
        78.0
      ],
      [
        960.0,
        1544.2799072265625,
        78.0
      ],
      [
        960.0,
        1305.7200927734375,
        78.0
      ],
      [
        960.0,
        1400.0,
        78.0
      ],
      [
        960.0,
        1305.7200927734375,
        78.0
      ],
      [
        960.0,
        1544.2799072265625,
        78.0
      ],
      [
        960.0,
        1400.0,
        78.0
      ],
      [
        960.0,
        1450.0,
        78.0
      ],
      [
        820.0,
        1540.0,
        78.0
      ],
      [
        820.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        820.0,
        1400.0,
        80.0
      ],
      [
        820.0,
        1310.0,
        80.0
      ],
      [
        820.0,
        1310.0,
        78.0
      ],
      [
        893.5803833007812,
        1450.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        896.850830078125,
        1472.83544921875,
        78.0
      ],
      [
        896.850830078125,
        1472.83544921875,
        80.0
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        80.0
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        78.0
      ],
      [
        945.5584716796875,
        1540.0,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        78.0
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        78.0
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        80.0
      ],
      [
        960.0,
        1553.1624755859375,
        78.0
      ],
      [
        960.0,
        1570.0,
        80.0
      ],
      [
        960.0,
        1553.1624755859375,
        80.0
      ],
      [
        893.5803833007812,
        1450.0,
        80.0
      ],
      [
        896.850830078125,
        1472.83544921875,
        80.0
      ],
      [
        896.850830078125,
        1472.83544921875,
        78.0
      ],
      [
        960.0,
        1550.0,
        80.0
      ],
      [
        960.0,
        1550.0,
        80.0
      ],
      [
        820.0,
        1400.0,
        80.0
      ],
      [
        893.5803833007812,
        1400.0,
        80.0
      ],
      [
        896.850830078125,
        1377.16455078125,
        80.0
      ],
      [
        896.850830078125,
        1377.16455078125,
        78.0
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        78.0
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        80.0
      ],
      [
        832.5558471679688,
        1280.0,
        80.0
      ],
      [
        832.5558471679688,
        1310.0,
        80.0
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        80.0
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        78.0
      ],
      [
        945.5584716796875,
        1310.0,
        78.0
      ],
      [
        945.5584716796875,
        1310.0,
        80.0
      ],
      [
        896.850830078125,
        1377.16455078125,
        78.0
      ],
      [
        896.850830078125,
        1377.16455078125,
        80.0
      ],
      [
        893.5803833007812,
        1400.0,
        80.0
      ],
      [
        960.0,
        1300.0,
        80.0
      ],
      [
        827.0,
        1404.0,
        80.0
      ],
      [
        827.0,
        1440.0,
        80.0
      ],
      [
        780.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1320.0,
        78.0
      ],
      [
        790.0,
        1320.0,
        78.0
      ],
      [
        790.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        78.0
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        790.0,
        1310.0,
        80.0
      ],
      [
        790.0,
        1310.0,
        78.0
      ],
      [
        780.0,
        1320.0,
        78.0
      ],
      [
        780.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        78.0
      ],
      [
        790.0,
        1530.0,
        80.0
      ],
      [
        790.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        1530.0,
        80.0
      ],
      [
        780.0,
        1540.0,
        78.0
      ],
      [
        780.0,
        1540.0,
        80.0
      ],
      [
        780.0,
        1530.0,
        80.0
      ],
      [
        780.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        650.0,
        78.0
      ],
      [
        780.0,
        650.0,
        80.0
      ],
      [
        650.0,
        520.0,
        80.0
      ],
      [
        650.0,
        520.0,
        78.0
      ],
      [
        830.0,
        700.0,
        80.0
      ],
      [
        830.0,
        700.0,
        78.0
      ],
      [
        992.0,
        862.0,
        78.0
      ],
      [
        1480.0,
        720.0,
        78.0
      ],
      [
        1480.0,
        720.0,
        80.0
      ],
      [
        1480.0,
        900.0,
        78.0
      ],
      [
        900.0,
        650.0,
        78.0
      ],
      [
        900.0,
        650.0,
        80.0
      ],
      [
        780.0,
        650.0,
        80.0
      ],
      [
        780.0,
        650.0,
        78.0
      ],
      [
        1770.0,
        900.0,
        78.0
      ],
      [
        1770.0,
        720.0,
        80.0
      ],
      [
        1770.0,
        720.0,
        78.0
      ],
      [
        1770.0,
        900.0,
        78.0
      ],
      [
        1750.0,
        900.0,
        78.0
      ],
      [
        1530.0,
        900.0,
        78.0
      ],
      [
        1480.0,
        900.0,
        78.0
      ],
      [
        760.0,
        689.9500122070312,
        78.0
      ],
      [
        770.0,
        689.9500122070312,
        78.0
      ],
      [
        1210.0,
        1830.0,
        118.0
      ],
      [
        1230.0,
        1830.0,
        118.0
      ],
      [
        905.0,
        1170.0,
        118.0
      ],
      [
        780.0,
        1170.0,
        118.0
      ],
      [
        1200.0,
        1170.0,
        118.0
      ],
      [
        1030.0,
        1170.0,
        118.0
      ],
      [
        1630.0,
        1170.0,
        118.0
      ],
      [
        1300.0,
        1170.0,
        118.0
      ],
      [
        1457.0,
        1427.0,
        118.0
      ],
      [
        1250.0,
        1220.0,
        118.0
      ],
      [
        1030.0,
        1690.0,
        118.0
      ],
      [
        980.0,
        1690.0,
        118.0
      ],
      [
        500.0,
        1690.0,
        118.0
      ],
      [
        780.0,
        1690.0,
        118.0
      ],
      [
        780.0,
        1280.0,
        118.0
      ],
      [
        980.0,
        1280.0,
        118.0
      ],
      [
        1030.0,
        1170.0,
        118.0
      ],
      [
        1030.0,
        1280.0,
        118.0
      ],
      [
        1030.0,
        1280.0,
        160.0
      ],
      [
        1200.0,
        1280.0,
        160.0
      ],
      [
        1200.0,
        1280.0,
        118.0
      ],
      [
        1200.0,
        1170.0,
        118.0
      ],
      [
        1250.0,
        1280.0,
        140.0
      ],
      [
        1250.0,
        1220.0,
        118.0
      ],
      [
        1250.0,
        1280.0,
        118.0
      ],
      [
        780.0,
        1170.0,
        118.0
      ],
      [
        780.0,
        1280.0,
        118.0
      ],
      [
        980.0,
        1280.0,
        118.0
      ],
      [
        980.0,
        1170.0,
        118.0
      ],
      [
        650.5369262695312,
        1175.6285400390625,
        118.00000762939453
      ],
      [
        708.0369262695312,
        1217.4046630859375,
        118.0
      ],
      [
        579.4630737304688,
        1175.6285400390625,
        118.00000762939453
      ],
      [
        650.5369262695312,
        1175.6285400390625,
        118.0
      ],
      [
        708.0369262695312,
        1217.4046630859375,
        118.00000762939453
      ],
      [
        728.3754272460938,
        1280.0,
        140.0
      ],
      [
        728.3754272460938,
        1280.0,
        118.0
      ],
      [
        730.0,
        1640.0,
        118.0
      ],
      [
        730.0,
        1450.0,
        118.00000762939453
      ],
      [
        640.0,
        1450.0,
        118.00000762939453
      ],
      [
        730.0,
        1450.0,
        118.0
      ],
      [
        730.0,
        1285.0,
        118.00000762939453
      ],
      [
        708.0369262695312,
        1352.5953369140625,
        118.0
      ],
      [
        708.0369262695312,
        1352.5953369140625,
        118.00000762939453
      ],
      [
        650.5369262695312,
        1394.3714599609375,
        118.0
      ],
      [
        650.5369262695312,
        1394.3714599609375,
        118.00000762939453
      ],
      [
        579.4630737304688,
        1394.3714599609375,
        118.0
      ],
      [
        730.0,
        1285.0,
        118.0
      ],
      [
        1030.0,
        1570.0,
        118.0
      ],
      [
        1200.0,
        1570.0,
        118.0
      ],
      [
        960.0,
        1300.0,
        118.0
      ],
      [
        980.0,
        1300.0,
        118.00000762939453
      ],
      [
        1030.0,
        1300.0,
        118.0
      ],
      [
        1200.0,
        1300.0,
        118.0
      ],
      [
        1200.0,
        1300.0,
        118.0
      ],
      [
        1030.0,
        1300.0,
        118.0
      ],
      [
        980.0,
        1280.0,
        118.00000762939453
      ],
      [
        980.0,
        1300.0,
        118.0
      ],
      [
        1250.0,
        1300.0,
        140.0
      ],
      [
        1250.0,
        1300.0,
        118.0
      ],
      [
        1070.0,
        1540.0,
        118.00000762939453
      ],
      [
        1180.0,
        1540.0,
        118.0
      ],
      [
        1250.0,
        1375.0,
        118.0
      ],
      [
        1090.0,
        1390.0,
        118.0
      ],
      [
        1090.0,
        1460.0,
        118.0
      ],
      [
        1200.0,
        1325.0,
        118.0
      ],
      [
        1200.0,
        1375.0,
        118.0
      ],
      [
        1250.0,
        1375.0,
        118.0
      ],
      [
        1200.0,
        1375.0,
        118.0
      ],
      [
        1050.0,
        1325.0,
        118.00000762939453
      ],
      [
        1050.0,
        1375.0,
        118.0
      ],
      [
        1050.0,
        1475.0,
        118.00000762939453
      ],
      [
        1050.0,
        1525.0,
        118.0
      ],
      [
        1050.0,
        1475.0,
        118.00000762939453
      ],
      [
        1050.0,
        1525.0,
        118.0
      ],
      [
        1090.0,
        1460.0,
        118.0
      ],
      [
        1070.0,
        1460.0,
        118.0
      ],
      [
        1050.0,
        1475.0,
        118.0
      ],
      [
        1070.0,
        1475.0,
        118.00000762939453
      ],
      [
        1050.0,
        1475.0,
        118.0
      ],
      [
        1070.0,
        1475.0,
        118.00000762939453
      ],
      [
        1050.0,
        1525.0,
        118.00000762939453
      ],
      [
        1070.0,
        1525.0,
        118.0
      ],
      [
        1070.0,
        1540.0,
        118.0
      ],
      [
        1070.0,
        1525.0,
        118.00000762939453
      ],
      [
        1070.0,
        1460.0,
        118.00000762939453
      ],
      [
        1070.0,
        1475.0,
        118.0
      ],
      [
        1070.0,
        1390.0,
        118.00000762939453
      ],
      [
        1090.0,
        1390.0,
        118.0
      ],
      [
        1050.0,
        1375.0,
        118.00000762939453
      ],
      [
        1070.0,
        1375.0,
        118.0
      ],
      [
        1070.0,
        1390.0,
        118.0
      ],
      [
        1070.0,
        1375.0,
        118.00000762939453
      ],
      [
        896.850830078125,
        1377.16455078125,
        118.0
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        118.00000762939453
      ],
      [
        896.850830078125,
        1472.83544921875,
        118.00000762939453
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        118.0
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        118.0
      ],
      [
        945.5584716796875,
        1310.0,
        118.0
      ],
      [
        945.5584716796875,
        1540.0,
        118.0
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        118.00000762939453
      ],
      [
        1030.0,
        1550.0,
        118.0
      ],
      [
        1030.0,
        1570.0,
        118.0
      ],
      [
        960.0,
        1550.0,
        118.0
      ],
      [
        960.0,
        1570.0,
        118.00000762939453
      ],
      [
        960.0,
        1550.0,
        118.00000762939453
      ],
      [
        980.0,
        1550.0,
        118.0
      ],
      [
        980.0,
        1550.0,
        118.00000762939453
      ],
      [
        980.0,
        1570.0,
        118.0
      ],
      [
        1200.0,
        1620.0,
        118.0
      ],
      [
        1030.0,
        1620.0,
        118.0
      ],
      [
        1030.0,
        1620.0,
        118.0
      ],
      [
        1030.0,
        1690.0,
        118.0
      ],
      [
        980.0,
        1690.0,
        118.0
      ],
      [
        980.0,
        1670.0,
        118.0
      ],
      [
        955.0,
        1655.0,
        118.0
      ],
      [
        980.0,
        1670.0,
        118.0
      ],
      [
        940.0,
        1646.0,
        140.0
      ],
      [
        940.0,
        1650.0,
        118.0
      ],
      [
        940.0,
        1646.0,
        118.0
      ],
      [
        940.0,
        1620.0,
        140.0
      ],
      [
        940.0,
        1620.0,
        118.0
      ],
      [
        962.5,
        1642.5,
        118.0
      ],
      [
        967.5,
        1642.5,
        118.0
      ],
      [
        962.5,
        1647.5,
        118.0
      ],
      [
        967.5,
        1647.5,
        118.0
      ],
      [
        967.5,
        1642.5,
        118.0
      ],
      [
        967.5,
        1647.5,
        118.0
      ],
      [
        1200.0,
        1570.0,
        118.0
      ],
      [
        1200.0,
        1620.0,
        118.0
      ],
      [
        980.0,
        1590.0,
        118.0
      ],
      [
        955.0,
        1605.0,
        118.0
      ],
      [
        980.0,
        1590.0,
        118.0
      ],
      [
        980.0,
        1570.0,
        118.0
      ],
      [
        940.0,
        1614.0,
        140.0
      ],
      [
        940.0,
        1614.0,
        118.0
      ],
      [
        940.0,
        1610.0,
        118.0
      ],
      [
        962.5,
        1612.5,
        118.0
      ],
      [
        967.5,
        1612.5,
        118.0
      ],
      [
        967.5,
        1612.5,
        118.0
      ],
      [
        967.5,
        1617.5,
        118.0
      ],
      [
        962.5,
        1617.5,
        118.0
      ],
      [
        967.5,
        1617.5,
        118.0
      ],
      [
        940.0,
        1617.5,
        140.0
      ],
      [
        940.0,
        1617.5,
        118.0
      ],
      [
        1300.0,
        1170.0,
        118.0
      ],
      [
        1507.0,
        1377.0,
        118.0
      ],
      [
        1630.0,
        1377.0,
        118.0
      ],
      [
        1630.0,
        1170.0,
        118.0
      ],
      [
        1680.0,
        1170.0,
        138.0
      ],
      [
        1660.0,
        1170.0,
        138.0
      ],
      [
        1680.0,
        1170.0,
        140.0
      ],
      [
        1680.0,
        1170.0,
        138.0
      ],
      [
        1680.0,
        1200.0,
        138.0
      ],
      [
        1680.0,
        1200.0,
        138.0
      ],
      [
        1680.0,
        1400.0,
        138.0
      ],
      [
        1680.0,
        1400.0,
        138.0
      ],
      [
        1630.0,
        1400.0,
        138.0
      ],
      [
        1680.0,
        1170.0,
        118.0
      ],
      [
        1680.0,
        1200.0,
        118.0
      ],
      [
        1680.0,
        1200.0,
        118.0
      ],
      [
        1680.0,
        1380.0,
        118.0
      ],
      [
        1630.0,
        1377.0,
        118.0
      ],
      [
        1680.0,
        1377.0,
        118.0
      ],
      [
        1280.0,
        1170.0,
        138.0
      ],
      [
        1530.0,
        1400.0,
        138.0
      ],
      [
        1480.0,
        1450.0,
        138.0
      ],
      [
        1457.0,
        1427.0,
        118.0
      ],
      [
        1507.0,
        1377.0,
        118.0
      ],
      [
        830.0,
        700.0,
        118.0
      ],
      [
        1010.0,
        880.0,
        118.0
      ],
      [
        1770.0,
        970.0,
        118.0
      ],
      [
        1680.0,
        970.0,
        118.00000762939453
      ],
      [
        1630.0,
        970.0,
        118.0
      ],
      [
        1380.0,
        970.0,
        118.00000762939453
      ],
      [
        1380.0,
        1111.0,
        118.0
      ],
      [
        1630.0,
        1111.0,
        118.0
      ],
      [
        1680.0,
        1100.0,
        140.0
      ],
      [
        1680.0,
        970.0,
        118.0
      ],
      [
        1680.0,
        1111.0,
        118.0
      ],
      [
        1250.0,
        970.0,
        118.0
      ],
      [
        1250.0,
        1111.0,
        118.0
      ],
      [
        1250.0,
        1101.0,
        138.0
      ],
      [
        1250.0,
        970.0,
        124.21052551269531
      ],
      [
        1630.0,
        1100.0,
        140.0
      ],
      [
        1630.0,
        1096.0,
        118.0
      ],
      [
        1630.0,
        970.0,
        118.0
      ],
      [
        1630.0,
        1096.0,
        118.0
      ],
      [
        1630.0,
        1111.0,
        118.0
      ],
      [
        1680.0,
        1101.0,
        138.0
      ],
      [
        1660.0,
        1101.0,
        138.0
      ],
      [
        1200.0,
        970.0,
        130.0
      ],
      [
        1200.0,
        1070.0,
        130.0
      ],
      [
        1200.0,
        1070.0,
        118.0
      ],
      [
        1200.0,
        970.0,
        118.00000762939453
      ],
      [
        1250.0,
        1120.0,
        118.0
      ],
      [
        1380.0,
        1120.0,
        118.0
      ],
      [
        1250.0,
        1110.0,
        138.94737243652344
      ],
      [
        1250.0,
        1110.0,
        120.0
      ],
      [
        1680.0,
        1110.0,
        140.0
      ],
      [
        1680.0,
        1110.0,
        120.0
      ],
      [
        1680.0,
        1110.0,
        138.0
      ],
      [
        1660.0,
        1110.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        130.0
      ],
      [
        1535.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        130.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1680.0,
        1120.0,
        138.0
      ],
      [
        1660.0,
        1120.0,
        138.0
      ],
      [
        1680.0,
        1110.0,
        138.0
      ],
      [
        1680.0,
        1120.0,
        138.0
      ],
      [
        1680.0,
        1120.0,
        130.00003051757812
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1455.0,
        1120.0,
        130.0
      ],
      [
        1250.0,
        1120.0,
        130.00003051757812
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1680.0,
        1120.0,
        118.0
      ],
      [
        1250.0,
        1120.0,
        118.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1128.0,
        138.0
      ],
      [
        1680.0,
        1128.0,
        138.0
      ],
      [
        1660.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1130.0,
        140.0
      ],
      [
        1680.0,
        1130.0,
        140.0
      ],
      [
        1680.0,
        1120.0,
        138.0
      ],
      [
        1680.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1680.0,
        1120.0,
        130.00003051757812
      ],
      [
        1680.0,
        1120.0,
        118.0
      ],
      [
        1290.0,
        1160.0,
        138.0
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1617.0,
        1170.0,
        118.0
      ],
      [
        1617.0,
        1160.0,
        118.0
      ],
      [
        1336.0,
        1160.0,
        118.0
      ],
      [
        1336.0,
        1150.0,
        118.0
      ],
      [
        1010.0,
        880.0,
        118.0
      ],
      [
        1250.0,
        880.0,
        118.0
      ],
      [
        1480.0,
        720.0,
        118.00000762939453
      ],
      [
        1480.0,
        880.0,
        140.0
      ],
      [
        1480.0,
        880.0,
        118.0
      ],
      [
        1770.0,
        880.0,
        136.0
      ],
      [
        1770.0,
        720.0,
        118.0
      ],
      [
        1770.0,
        880.0,
        118.00000762939453
      ],
      [
        1750.0,
        840.0,
        118.0
      ],
      [
        1600.0,
        840.0,
        118.0
      ],
      [
        1600.0,
        880.0,
        118.0
      ],
      [
        1600.0,
        840.0,
        118.0
      ],
      [
        1600.0,
        880.0,
        140.0
      ],
      [
        1060.0,
        930.0,
        130.0
      ],
      [
        1200.0,
        930.0,
        118.0
      ],
      [
        1060.0,
        930.0,
        118.00000762939453
      ],
      [
        1380.0,
        970.0,
        118.0
      ],
      [
        1380.0,
        930.0,
        118.00000762939453
      ],
      [
        1380.0,
        930.0,
        140.0
      ],
      [
        1200.0,
        930.0,
        118.00000762939453
      ],
      [
        1250.0,
        930.0,
        118.0
      ],
      [
        1770.0,
        930.0,
        140.0
      ],
      [
        1770.0,
        930.0,
        118.0
      ],
      [
        1770.0,
        970.0,
        118.0
      ],
      [
        1380.0,
        920.0,
        118.0
      ],
      [
        1480.0,
        920.0,
        118.00000762939453
      ],
      [
        1600.0,
        920.0,
        118.0
      ],
      [
        1480.0,
        920.0,
        118.0
      ],
      [
        1250.0,
        920.0,
        120.0
      ],
      [
        1250.0,
        880.0,
        118.0
      ],
      [
        1250.0,
        920.0,
        118.0
      ],
      [
        1770.0,
        920.0,
        118.00000762939453
      ],
      [
        1380.0,
        920.0,
        118.00000762939453
      ],
      [
        1250.0,
        930.0,
        118.0
      ],
      [
        1770.0,
        920.0,
        118.0
      ],
      [
        960.0,
        1120.0,
        118.0
      ],
      [
        950.0,
        1120.0,
        118.0
      ],
      [
        1010.0,
        1120.0,
        118.0
      ],
      [
        1200.0,
        1120.0,
        118.0
      ],
      [
        500.0,
        1120.0,
        118.0
      ],
      [
        730.0,
        1120.0,
        118.0
      ],
      [
        780.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        1010.0,
        930.0,
        118.00000762939453
      ],
      [
        730.0,
        930.0,
        118.0
      ],
      [
        500.0,
        930.0,
        118.0
      ],
      [
        730.0,
        700.0,
        118.0
      ],
      [
        730.0,
        930.0,
        118.0
      ],
      [
        780.0,
        750.0,
        118.0
      ],
      [
        780.0,
        930.0,
        118.0
      ],
      [
        500.0,
        970.0,
        118.0
      ],
      [
        730.0,
        970.0,
        118.0
      ],
      [
        1010.0,
        970.0,
        130.0
      ],
      [
        1010.0,
        970.0,
        118.0
      ],
      [
        1010.0,
        1120.0,
        118.00000762939453
      ],
      [
        1200.0,
        1120.0,
        118.0
      ],
      [
        730.0,
        970.0,
        118.0
      ],
      [
        730.0,
        1120.0,
        118.0
      ],
      [
        1010.0,
        930.0,
        118.0
      ],
      [
        980.0,
        1170.0,
        118.0
      ],
      [
        960.0,
        1120.0,
        118.0
      ],
      [
        905.0,
        1120.0,
        118.0
      ],
      [
        905.0,
        1170.0,
        118.0
      ],
      [
        1030.0,
        1690.0,
        110.86956024169922
      ],
      [
        980.0,
        1690.0,
        108.69564819335938
      ],
      [
        500.0,
        1690.0,
        87.82608032226562
      ],
      [
        780.0,
        1690.0,
        100.0
      ],
      [
        780.0,
        1280.0,
        82.17391967773438
      ],
      [
        980.0,
        1280.0,
        90.86956787109375
      ],
      [
        1030.0,
        1170.0,
        88.26087188720703
      ],
      [
        1030.0,
        1280.0,
        80.0
      ],
      [
        1030.0,
        1280.0,
        93.04347229003906
      ],
      [
        1680.0,
        1170.0,
        100.0
      ],
      [
        1680.0,
        1200.0,
        102.60868835449219
      ],
      [
        1680.0,
        1200.0,
        102.60868835449219
      ],
      [
        1680.0,
        1280.0,
        108.0
      ],
      [
        1680.0,
        1280.0,
        109.56521606445312
      ],
      [
        1250.0,
        1280.0,
        100.0
      ],
      [
        1250.0,
        1280.0,
        102.60869598388672
      ],
      [
        1200.0,
        1280.0,
        100.0
      ],
      [
        1200.0,
        1270.0,
        100.0
      ],
      [
        1200.0,
        1280.0,
        100.43478393554688
      ],
      [
        980.0,
        1280.0,
        90.86956787109375
      ],
      [
        980.0,
        1170.0,
        86.08695983886719
      ],
      [
        780.0,
        1229.9998779296875,
        80.0
      ],
      [
        780.0,
        1280.0,
        82.17391967773438
      ],
      [
        730.0,
        1670.0,
        96.95652770996094
      ],
      [
        730.0,
        1690.0,
        97.82608795166016
      ],
      [
        730.0,
        1640.0,
        95.65217590332031
      ],
      [
        730.0,
        1450.0,
        87.39130401611328
      ],
      [
        640.0,
        1450.0,
        83.478271484375
      ],
      [
        730.0,
        1450.0,
        87.39130401611328
      ],
      [
        722.40966796875,
        1670.0,
        96.62651062011719
      ],
      [
        730.0,
        1670.0,
        96.95652770996094
      ],
      [
        730.0,
        1285.0,
        80.21739196777344
      ],
      [
        708.0369262695312,
        1352.5953369140625,
        82.20140838623047
      ],
      [
        708.0369262695312,
        1352.5953369140625,
        82.20140838623047
      ],
      [
        650.5369262695312,
        1394.3714599609375,
        81.51776123046875
      ],
      [
        615.62841796875,
        1394.3714599609375,
        80.0
      ],
      [
        650.5369262695312,
        1394.3714599609375,
        81.51776123046875
      ],
      [
        728.7738037109375,
        1281.22607421875,
        80.0
      ],
      [
        730.0,
        1285.0,
        80.21739959716797
      ],
      [
        1680.0,
        1376.9998779296875,
        118.0
      ],
      [
        1250.0,
        1375.0,
        105.88235473632812
      ],
      [
        1250.0,
        1355.294189453125,
        105.88235473632812
      ],
      [
        1250.0,
        1375.0,
        105.88235473632812
      ],
      [
        1030.0,
        1570.0,
        105.65217590332031
      ],
      [
        1200.0,
        1570.0,
        113.04347229003906
      ],
      [
        899.9998779296875,
        1570.0,
        100.0
      ],
      [
        780.0,
        1570.0,
        94.7826156616211
      ],
      [
        1200.0,
        1620.0,
        115.21739196777344
      ],
      [
        1030.0,
        1620.0,
        107.82609558105469
      ],
      [
        1030.0,
        1620.0,
        107.82609558105469
      ],
      [
        1030.0,
        1690.0,
        110.86956024169922
      ],
      [
        980.0,
        1690.0,
        108.69564819335938
      ],
      [
        980.0,
        1670.0,
        107.82609558105469
      ],
      [
        980.0,
        1620.0,
        100.0
      ],
      [
        980.0,
        1620.0,
        80.0
      ],
      [
        780.0,
        1620.0,
        96.95652770996094
      ],
      [
        780.0,
        1620.0,
        80.0
      ],
      [
        940.0,
        1650.0,
        105.21739196777344
      ],
      [
        940.0,
        1620.0,
        100.0
      ],
      [
        940.0,
        1620.0,
        103.91304016113281
      ],
      [
        955.0,
        1655.0,
        106.08695983886719
      ],
      [
        980.0,
        1670.0,
        107.82609558105469
      ],
      [
        962.5,
        1647.5,
        106.08695983886719
      ],
      [
        967.5,
        1647.5,
        106.30435180664062
      ],
      [
        967.5,
        1642.5,
        106.08695983886719
      ],
      [
        967.5,
        1647.5,
        106.30435180664062
      ],
      [
        962.5,
        1642.5,
        105.86956787109375
      ],
      [
        967.5,
        1642.5,
        106.08695983886719
      ],
      [
        734.0,
        1690.0,
        98.0
      ],
      [
        753.9998779296875,
        1670.0,
        98.0
      ],
      [
        760.0,
        1663.9998779296875,
        98.0
      ],
      [
        780.0,
        1643.9998779296875,
        98.0
      ],
      [
        980.0,
        1620.0,
        98.0
      ],
      [
        980.0,
        1590.0,
        104.34782409667969
      ],
      [
        980.0,
        1570.0,
        103.47826385498047
      ],
      [
        780.0,
        1570.0,
        94.7826156616211
      ],
      [
        980.0,
        1590.0,
        104.34782409667969
      ],
      [
        955.0,
        1605.0,
        103.91304779052734
      ],
      [
        940.0,
        1614.0,
        100.0
      ],
      [
        940.0,
        1610.0,
        103.47825622558594
      ],
      [
        940.0,
        1614.0,
        103.65216827392578
      ],
      [
        962.5,
        1617.5,
        104.7826156616211
      ],
      [
        967.5,
        1617.5,
        105.0
      ],
      [
        967.5,
        1612.5,
        104.78260803222656
      ],
      [
        967.5,
        1617.5,
        105.0
      ],
      [
        962.5,
        1612.5,
        104.56521606445312
      ],
      [
        967.5,
        1612.5,
        104.78260803222656
      ],
      [
        1200.0,
        1570.0,
        113.04347229003906
      ],
      [
        1200.0,
        1620.0,
        115.21739196777344
      ],
      [
        980.0,
        1570.0,
        98.0
      ],
      [
        1000.0,
        1570.0,
        98.0
      ],
      [
        1016.5088500976562,
        1610.0,
        106.80473327636719
      ],
      [
        1017.3964233398438,
        1620.0,
        107.27810668945312
      ],
      [
        960.0,
        1300.0,
        90.86956787109375
      ],
      [
        980.0,
        1300.0,
        91.73912811279297
      ],
      [
        1030.0,
        1300.0,
        93.91304016113281
      ],
      [
        1200.0,
        1300.0,
        101.3043441772461
      ],
      [
        871.0581665039062,
        1280.0,
        86.13297271728516
      ],
      [
        878.566650390625,
        1300.0,
        87.32898712158203
      ],
      [
        832.5558471679688,
        1300.0,
        80.0
      ],
      [
        1030.0,
        1300.0,
        93.91304016113281
      ],
      [
        1200.0,
        1300.0,
        101.3043441772461
      ],
      [
        980.0,
        1280.0,
        90.86956787109375
      ],
      [
        980.0,
        1300.0,
        91.73912811279297
      ],
      [
        1013.9999389648438,
        1410.0,
        98.0
      ],
      [
        1033.9998779296875,
        1390.0,
        98.0
      ],
      [
        914.4931030273438,
        1509.5068359375,
        98.0
      ],
      [
        980.0,
        1444.0,
        98.0
      ],
      [
        980.0,
        1444.0,
        98.0
      ],
      [
        1000.0,
        1423.9998779296875,
        98.0
      ],
      [
        1070.0,
        1540.0,
        106.08695983886719
      ],
      [
        1070.0,
        1540.0,
        98.0
      ],
      [
        1180.0,
        1540.0,
        98.0
      ],
      [
        1180.0,
        1540.0,
        110.86956787109375
      ],
      [
        1090.0,
        1390.0,
        100.43478393554688
      ],
      [
        1090.0,
        1390.0,
        98.0
      ],
      [
        1090.0,
        1460.0,
        98.0
      ],
      [
        1090.0,
        1460.0,
        103.47825622558594
      ],
      [
        1250.0,
        1375.0,
        106.73912811279297
      ],
      [
        1200.0,
        1375.0,
        104.56521606445312
      ],
      [
        1200.0,
        1325.0,
        102.39130401611328
      ],
      [
        1200.0,
        1375.0,
        104.56521606445312
      ],
      [
        1250.0,
        1375.0,
        106.73912811279297
      ],
      [
        1050.0,
        1375.0,
        98.0
      ],
      [
        1050.0,
        1375.0,
        98.04347229003906
      ],
      [
        1050.0,
        1374.0001220703125,
        98.0
      ],
      [
        1050.0,
        1475.0,
        102.39130401611328
      ],
      [
        1050.0,
        1475.0,
        98.0
      ],
      [
        1050.0,
        1525.0,
        98.0
      ],
      [
        1050.0,
        1525.0,
        104.56521606445312
      ],
      [
        1050.0,
        1475.0,
        102.39130401611328
      ],
      [
        1050.0,
        1475.0,
        98.0
      ],
      [
        1050.0,
        1525.0,
        98.0
      ],
      [
        1050.0,
        1525.0,
        104.56521606445312
      ],
      [
        1050.0,
        1525.0,
        104.56521606445312
      ],
      [
        1050.0,
        1525.0,
        98.0
      ],
      [
        1070.0,
        1525.0,
        98.0
      ],
      [
        1070.0,
        1525.0,
        105.43478393554688
      ],
      [
        1090.0,
        1460.0,
        103.47825622558594
      ],
      [
        1090.0,
        1460.0,
        98.0
      ],
      [
        1070.0,
        1460.0,
        98.0
      ],
      [
        1070.0,
        1460.0,
        102.60868835449219
      ],
      [
        1050.0,
        1475.0,
        98.0
      ],
      [
        1050.0,
        1475.0,
        102.39130401611328
      ],
      [
        1070.0,
        1475.0,
        103.26087188720703
      ],
      [
        1070.0,
        1475.0,
        98.0
      ],
      [
        1050.0,
        1475.0,
        98.0
      ],
      [
        1050.0,
        1475.0,
        102.39130401611328
      ],
      [
        1070.0,
        1475.0,
        103.26087188720703
      ],
      [
        1070.0,
        1475.0,
        98.0
      ],
      [
        1070.0,
        1460.0,
        102.60868835449219
      ],
      [
        1070.0,
        1460.0,
        98.0
      ],
      [
        1070.0,
        1475.0,
        98.0
      ],
      [
        1070.0,
        1475.0,
        103.26087188720703
      ],
      [
        1070.0,
        1390.0,
        99.56521606445312
      ],
      [
        1070.0,
        1390.0,
        98.0
      ],
      [
        1090.0,
        1390.0,
        98.0
      ],
      [
        1090.0,
        1390.0,
        100.43478393554688
      ],
      [
        1050.0,
        1375.0,
        98.04347229003906
      ],
      [
        1050.0,
        1375.0,
        98.0
      ],
      [
        1070.0,
        1375.0,
        98.0
      ],
      [
        1070.0,
        1375.0,
        98.91304016113281
      ],
      [
        1070.0,
        1390.0,
        98.0
      ],
      [
        1070.0,
        1390.0,
        99.56521606445312
      ],
      [
        1070.0,
        1375.0,
        98.91304016113281
      ],
      [
        1070.0,
        1375.0,
        98.0
      ],
      [
        1070.0,
        1540.0,
        98.0
      ],
      [
        1070.0,
        1540.0,
        106.08695983886719
      ],
      [
        1070.0,
        1525.0,
        105.43478393554688
      ],
      [
        1070.0,
        1525.0,
        98.0
      ],
      [
        945.5584716796875,
        1540.0,
        100.67645263671875
      ],
      [
        945.5584716796875,
        1540.0,
        98.0
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        98.0
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        98.24994659423828
      ],
      [
        914.4931030273438,
        1509.5068359375,
        98.0
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        98.24994659423828
      ],
      [
        916.3604125976562,
        1513.3883056640625,
        98.0
      ],
      [
        1030.0,
        1550.0,
        104.78260803222656
      ],
      [
        1030.0,
        1550.0,
        98.0
      ],
      [
        1030.0,
        1570.0,
        98.0
      ],
      [
        1030.0,
        1570.0,
        105.65217590332031
      ],
      [
        980.0,
        1550.0,
        98.0
      ],
      [
        980.0,
        1550.0,
        102.60868835449219
      ],
      [
        980.0,
        1570.0,
        103.47826385498047
      ],
      [
        980.0,
        1570.0,
        98.0
      ],
      [
        960.0,
        1550.0,
        101.7391357421875
      ],
      [
        960.0,
        1550.0,
        98.0
      ],
      [
        960.0,
        1570.0,
        98.0
      ],
      [
        960.0,
        1570.0,
        102.60870361328125
      ],
      [
        960.0,
        1550.0,
        98.0
      ],
      [
        960.0,
        1550.0,
        101.7391357421875
      ],
      [
        980.0,
        1550.0,
        102.60868835449219
      ],
      [
        980.0,
        1550.0,
        98.0
      ],
      [
        820.0,
        1540.0,
        95.21739196777344
      ],
      [
        820.0,
        1450.0,
        91.30435180664062
      ],
      [
        820.0,
        1400.0,
        89.13043975830078
      ],
      [
        820.0,
        1310.0,
        85.21739196777344
      ],
      [
        893.5803833007812,
        1450.0,
        94.50349426269531
      ],
      [
        820.0,
        1450.0,
        91.30435180664062
      ],
      [
        1090.0,
        1450.0,
        87.05882263183594
      ],
      [
        1090.0,
        1450.0,
        98.0
      ],
      [
        896.850830078125,
        1472.83544921875,
        95.63853454589844
      ],
      [
        893.5803833007812,
        1450.0,
        94.50349426269531
      ],
      [
        896.850830078125,
        1472.83544921875,
        95.63854217529297
      ],
      [
        820.0,
        1400.0,
        89.13043975830078
      ],
      [
        893.5803833007812,
        1400.0,
        92.32958221435547
      ],
      [
        1050.0,
        1325.0,
        95.86956024169922
      ],
      [
        1090.0,
        1400.0,
        87.05882263183594
      ],
      [
        1090.0,
        1400.0,
        98.0
      ],
      [
        882.3209228515625,
        1310.0,
        87.92699432373047
      ],
      [
        896.850830078125,
        1377.16455078125,
        90.24144744873047
      ],
      [
        896.850830078125,
        1377.16455078125,
        91.47893524169922
      ],
      [
        893.5803833007812,
        1400.0,
        92.32958221435547
      ],
      [
        893.5803833007812,
        1400.0,
        89.72048950195312
      ],
      [
        896.850830078125,
        1377.16455078125,
        91.47893524169922
      ],
      [
        896.850830078125,
        1377.16455078125,
        90.24144744873047
      ],
      [
        902.8526611328125,
        1364.68896484375,
        91.19747161865234
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        90.56400299072266
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        90.56400299072266
      ],
      [
        945.5584716796875,
        1310.0,
        90.67646026611328
      ],
      [
        1000.0,
        1386.761962890625,
        96.3809585571289
      ],
      [
        1010.0,
        1387.71435546875,
        96.85714721679688
      ],
      [
        1010.0,
        1383.3333740234375,
        96.66667175292969
      ],
      [
        1000.0,
        1382.3809814453125,
        96.19047546386719
      ],
      [
        1000.0,
        1382.3809814453125,
        96.19047546386719
      ],
      [
        1000.0,
        1386.761962890625,
        96.3809585571289
      ],
      [
        866.6666870117188,
        1404.0,
        91.33333587646484
      ],
      [
        873.1282348632812,
        1440.0,
        93.17948913574219
      ],
      [
        790.0,
        1530.0,
        93.47826385498047
      ],
      [
        780.0,
        1530.0,
        93.04348754882812
      ],
      [
        780.0,
        1540.0,
        93.47826385498047
      ],
      [
        780.0,
        1530.0,
        93.04348754882812
      ],
      [
        780.0,
        1320.0,
        83.91304779052734
      ],
      [
        790.0,
        1320.0,
        84.34783172607422
      ],
      [
        780.0,
        1310.0,
        83.47825622558594
      ],
      [
        790.0,
        1310.0,
        83.91304779052734
      ],
      [
        780.0,
        1320.0,
        83.91304779052734
      ],
      [
        780.0,
        1310.0,
        83.47825622558594
      ],
      [
        1630.0,
        1170.0,
        114.34783172607422
      ],
      [
        1630.0,
        1254.0,
        118.0
      ],
      [
        1680.0,
        1200.0,
        117.82608032226562
      ],
      [
        1680.0,
        1170.0,
        116.52174377441406
      ],
      [
        1680.0,
        1200.0,
        117.82608032226562
      ],
      [
        1680.0,
        1204.0001220703125,
        118.0
      ],
      [
        1680.0,
        1170.0,
        118.0
      ],
      [
        728.3754272460938,
        1280.0,
        80.0
      ],
      [
        728.3754272460938,
        1280.0,
        118.0
      ],
      [
        1030.0,
        1280.0,
        93.04347229003906
      ],
      [
        1030.0,
        1280.0,
        118.0
      ],
      [
        1200.0,
        1280.0,
        100.43478393554688
      ],
      [
        1200.0,
        1280.0,
        118.0
      ],
      [
        1250.0,
        1280.0,
        102.60869598388672
      ],
      [
        1250.0,
        1280.0,
        118.0
      ],
      [
        1020.0,
        1170.0,
        98.0
      ],
      [
        1020.0,
        1280.0,
        98.0
      ],
      [
        1000.0,
        1170.0,
        98.0
      ],
      [
        945.5584716796875,
        1300.0,
        98.0
      ],
      [
        878.566650390625,
        1300.0,
        87.32898712158203
      ],
      [
        980.0,
        1280.0,
        103.48612976074219
      ],
      [
        980.0,
        1300.0,
        103.48612213134766
      ],
      [
        1030.0,
        1300.0,
        111.45054626464844
      ],
      [
        1030.0,
        1280.0,
        111.45054626464844
      ],
      [
        945.5584716796875,
        1300.0,
        98.0
      ],
      [
        980.0,
        1300.0,
        98.0
      ],
      [
        1030.0,
        1300.0,
        98.0
      ],
      [
        1030.0,
        1280.0,
        98.0
      ],
      [
        980.0,
        1280.0,
        98.0
      ],
      [
        980.0,
        1300.0,
        98.0
      ],
      [
        1250.0,
        1300.0,
        103.47826385498047
      ],
      [
        1250.0,
        1300.0,
        118.0
      ],
      [
        1050.0,
        1325.0,
        98.0
      ],
      [
        1050.0,
        1374.0001220703125,
        98.0
      ],
      [
        896.850830078125,
        1377.16455078125,
        98.0
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        98.0
      ],
      [
        780.0,
        1320.0,
        98.0
      ],
      [
        790.0,
        1320.0,
        98.0
      ],
      [
        780.0,
        1310.0,
        98.0
      ],
      [
        790.0,
        1310.0,
        98.0
      ],
      [
        780.0,
        1320.0,
        98.0
      ],
      [
        780.0,
        1310.0,
        98.0
      ],
      [
        790.0,
        1530.0,
        98.0
      ],
      [
        780.0,
        1530.0,
        98.0
      ],
      [
        780.0,
        1540.0,
        98.0
      ],
      [
        780.0,
        1530.0,
        98.0
      ],
      [
        896.850830078125,
        1472.83544921875,
        98.0
      ],
      [
        914.4931030273438,
        1509.5068359375,
        98.0
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        98.0
      ],
      [
        945.5584716796875,
        1310.0,
        98.0
      ],
      [
        1010.0,
        1386.0,
        98.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        902.8526611328125,
        1364.68896484375,
        91.19747161865234
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        93.34909057617188
      ],
      [
        916.3604125976562,
        1336.6116943359375,
        93.34909057617188
      ],
      [
        780.0,
        1620.0,
        100.0
      ],
      [
        780.0,
        1620.0,
        96.95652770996094
      ],
      [
        940.0,
        1620.0,
        103.91304016113281
      ],
      [
        940.0,
        1620.0,
        118.0
      ],
      [
        760.0,
        1620.0,
        98.0
      ],
      [
        780.0,
        1620.0,
        98.0
      ],
      [
        780.0,
        1570.0,
        98.0
      ],
      [
        780.0,
        1620.0,
        98.0
      ],
      [
        940.0,
        1614.0,
        103.65216827392578
      ],
      [
        940.0,
        1614.0,
        118.0
      ],
      [
        780.0,
        650.0,
        98.0
      ],
      [
        650.0,
        520.0,
        98.0
      ],
      [
        830.0,
        700.0,
        100.0
      ],
      [
        830.0,
        700.0,
        98.0
      ],
      [
        1010.0,
        880.0,
        98.0
      ],
      [
        1010.0,
        880.0,
        100.0
      ],
      [
        1770.0,
        970.0,
        100.0
      ],
      [
        1770.0,
        970.0,
        98.0
      ],
      [
        1680.0,
        970.0,
        98.0
      ],
      [
        1680.0,
        970.0,
        100.0
      ],
      [
        1630.0,
        970.0,
        100.0
      ],
      [
        1630.0,
        970.0,
        98.0
      ],
      [
        1380.0,
        970.0,
        98.0
      ],
      [
        1380.0,
        970.0,
        100.0
      ],
      [
        1630.0,
        1105.0,
        98.0
      ],
      [
        1630.0,
        970.0,
        98.0
      ],
      [
        1250.0,
        970.0,
        98.0
      ],
      [
        1250.0,
        1101.0,
        98.0
      ],
      [
        1250.0,
        970.0,
        100.0
      ],
      [
        1200.0,
        1070.0,
        98.0
      ],
      [
        1200.0,
        970.0,
        98.0
      ],
      [
        1200.0,
        970.0,
        100.0
      ],
      [
        1200.0,
        1070.0,
        100.0
      ],
      [
        1250.0,
        1101.0,
        98.0
      ],
      [
        1231.0,
        1101.0,
        98.0
      ],
      [
        1680.0,
        970.0,
        100.0
      ],
      [
        1680.0,
        970.0,
        98.0
      ],
      [
        1680.0,
        1105.0,
        98.0
      ],
      [
        1630.0,
        1105.0,
        98.0
      ],
      [
        1680.0,
        1105.0,
        98.0
      ],
      [
        1010.0,
        880.0,
        100.0
      ],
      [
        1010.0,
        880.0,
        98.0
      ],
      [
        1250.0,
        880.0,
        98.0
      ],
      [
        1250.0,
        880.0,
        100.0
      ],
      [
        1480.0,
        720.0,
        98.0
      ],
      [
        1480.0,
        720.0,
        100.0
      ],
      [
        1480.0,
        880.0,
        100.0
      ],
      [
        1480.0,
        880.0,
        98.0
      ],
      [
        900.0,
        650.0,
        98.0
      ],
      [
        780.0,
        650.0,
        98.0
      ],
      [
        1770.0,
        880.0,
        100.0
      ],
      [
        1770.0,
        720.0,
        100.0
      ],
      [
        1770.0,
        720.0,
        98.0
      ],
      [
        1770.0,
        880.0,
        98.0
      ],
      [
        1380.0,
        920.0,
        100.0
      ],
      [
        1380.0,
        920.0,
        98.0
      ],
      [
        1480.0,
        920.0,
        98.0
      ],
      [
        1480.0,
        920.0,
        100.0
      ],
      [
        1750.0,
        920.0,
        98.0
      ],
      [
        1530.0,
        920.0,
        98.0
      ],
      [
        1480.0,
        920.0,
        100.0
      ],
      [
        1480.0,
        920.0,
        98.0
      ],
      [
        1250.0,
        880.0,
        100.0
      ],
      [
        1250.0,
        880.0,
        98.0
      ],
      [
        1250.0,
        920.0,
        98.0
      ],
      [
        1250.0,
        920.0,
        100.0
      ],
      [
        1770.0,
        920.0,
        98.0
      ],
      [
        1770.0,
        920.0,
        100.0
      ],
      [
        1200.0,
        930.0,
        100.0
      ],
      [
        1200.0,
        930.0,
        98.0
      ],
      [
        1060.0,
        930.0,
        98.0
      ],
      [
        1060.0,
        930.0,
        100.0
      ],
      [
        1380.0,
        970.0,
        100.0
      ],
      [
        1380.0,
        970.0,
        98.0
      ],
      [
        1380.0,
        930.0,
        98.0
      ],
      [
        1380.0,
        930.0,
        100.0
      ],
      [
        1250.0,
        930.0,
        100.0
      ],
      [
        1250.0,
        930.0,
        98.0
      ],
      [
        1200.0,
        930.0,
        98.0
      ],
      [
        1200.0,
        930.0,
        100.0
      ],
      [
        1770.0,
        930.0,
        98.0
      ],
      [
        1770.0,
        970.0,
        98.0
      ],
      [
        1770.0,
        970.0,
        100.0
      ],
      [
        1770.0,
        930.0,
        100.0
      ],
      [
        1650.0,
        963.0,
        100.0
      ],
      [
        1660.0,
        963.0,
        100.0
      ],
      [
        1380.0,
        920.0,
        98.0
      ],
      [
        1380.0,
        920.0,
        100.0
      ],
      [
        1250.0,
        930.0,
        98.0
      ],
      [
        1250.0,
        930.0,
        100.0
      ],
      [
        1770.0,
        920.0,
        100.0
      ],
      [
        1770.0,
        920.0,
        98.0
      ],
      [
        960.0,
        1120.0,
        100.0
      ],
      [
        960.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        780.0,
        1120.0,
        100.0
      ],
      [
        780.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        1010.0,
        1120.0,
        100.0
      ],
      [
        1010.0,
        1120.0,
        98.0
      ],
      [
        1181.0,
        1120.0,
        98.0
      ],
      [
        500.0,
        1120.0,
        100.0
      ],
      [
        500.0,
        1120.0,
        98.0
      ],
      [
        730.0,
        1120.0,
        98.0
      ],
      [
        780.0,
        930.0,
        100.0
      ],
      [
        780.0,
        930.0,
        98.0
      ],
      [
        960.0,
        930.0,
        98.0
      ],
      [
        1010.0,
        930.0,
        98.0
      ],
      [
        1010.0,
        930.0,
        100.0
      ],
      [
        730.0,
        930.0,
        98.0
      ],
      [
        730.0,
        930.0,
        100.0
      ],
      [
        500.0,
        930.0,
        100.0
      ],
      [
        500.0,
        930.0,
        98.0
      ],
      [
        730.0,
        700.0,
        98.0
      ],
      [
        730.0,
        700.0,
        100.0
      ],
      [
        730.0,
        930.0,
        100.0
      ],
      [
        730.0,
        930.0,
        98.0
      ],
      [
        780.0,
        750.0,
        100.0
      ],
      [
        780.0,
        750.0,
        98.0
      ],
      [
        780.0,
        930.0,
        98.0
      ],
      [
        780.0,
        930.0,
        100.0
      ],
      [
        942.0,
        912.0,
        98.0
      ],
      [
        960.0,
        930.0,
        98.0
      ],
      [
        780.0,
        970.0,
        98.0
      ],
      [
        780.0,
        970.0,
        100.0
      ],
      [
        950.0,
        970.0,
        100.0
      ],
      [
        950.0,
        970.0,
        98.0
      ],
      [
        500.0,
        970.0,
        98.0
      ],
      [
        500.0,
        970.0,
        100.0
      ],
      [
        730.0,
        970.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        950.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        970.0,
        98.0
      ],
      [
        950.0,
        970.0,
        100.0
      ],
      [
        730.0,
        970.0,
        98.0
      ],
      [
        730.0,
        1120.0,
        98.0
      ],
      [
        780.0,
        970.0,
        100.0
      ],
      [
        780.0,
        970.0,
        98.0
      ],
      [
        780.0,
        1120.0,
        98.0
      ],
      [
        780.0,
        1120.0,
        100.0
      ],
      [
        1010.0,
        970.0,
        98.0
      ],
      [
        1010.0,
        1120.0,
        98.0
      ],
      [
        1010.0,
        1120.0,
        100.0
      ],
      [
        1010.0,
        970.0,
        100.0
      ],
      [
        1200.0,
        1101.0,
        98.0
      ],
      [
        1200.0,
        1101.0,
        98.0
      ],
      [
        950.0,
        1096.0,
        100.0
      ],
      [
        960.0,
        1096.0,
        100.0
      ],
      [
        1010.0,
        930.0,
        100.0
      ],
      [
        1010.0,
        930.0,
        98.0
      ],
      [
        980.0,
        1170.0,
        100.0
      ],
      [
        980.0,
        1170.0,
        98.0
      ],
      [
        960.0,
        1120.0,
        98.0
      ],
      [
        960.0,
        1120.0,
        100.0
      ],
      [
        905.0,
        1120.0,
        100.0
      ],
      [
        905.0,
        1120.0,
        98.0
      ],
      [
        905.0,
        1170.0,
        98.0
      ],
      [
        905.0,
        1170.0,
        100.0
      ],
      [
        858.3333740234375,
        1120.0,
        100.0
      ],
      [
        861.6666870117188,
        1120.0,
        98.0
      ],
      [
        861.6666870117188,
        1130.0,
        98.0
      ],
      [
        858.3333740234375,
        1130.0,
        100.0
      ],
      [
        1183.0,
        1170.0,
        98.0
      ],
      [
        1183.0,
        1125.0,
        98.0
      ],
      [
        1181.0,
        1120.0,
        98.0
      ],
      [
        1183.0,
        1125.0,
        98.0
      ],
      [
        1250.0,
        970.0,
        100.0
      ],
      [
        1250.0,
        1111.0,
        118.0
      ],
      [
        1250.0,
        970.0,
        118.0
      ],
      [
        1680.0,
        1111.0,
        118.0
      ],
      [
        1650.0,
        970.0,
        104.66666412353516
      ],
      [
        1660.0,
        970.0,
        104.66666412353516
      ],
      [
        1200.0,
        1070.0,
        100.0
      ],
      [
        1200.0,
        970.0,
        100.0
      ],
      [
        1200.0,
        970.0,
        118.00000762939453
      ],
      [
        1200.0,
        1070.0,
        118.0
      ],
      [
        1770.0,
        880.0,
        118.00000762939453
      ],
      [
        1770.0,
        880.0,
        100.0
      ],
      [
        1480.0,
        880.0,
        118.0
      ],
      [
        1480.0,
        880.0,
        100.0
      ],
      [
        1600.0,
        880.0,
        100.0
      ],
      [
        1600.0,
        880.0,
        118.0
      ],
      [
        1060.0,
        930.0,
        100.0
      ],
      [
        1060.0,
        930.0,
        118.00000762939453
      ],
      [
        1380.0,
        930.0,
        100.0
      ],
      [
        1380.0,
        930.0,
        118.00000762939453
      ],
      [
        1770.0,
        930.0,
        100.0
      ],
      [
        1770.0,
        930.0,
        118.0
      ],
      [
        1250.0,
        920.0,
        100.0
      ],
      [
        1250.0,
        920.0,
        118.0
      ],
      [
        1010.0,
        970.0,
        100.0
      ],
      [
        1010.0,
        970.0,
        118.0
      ],
      [
        950.0,
        1090.0,
        103.00000762939453
      ],
      [
        1250.0,
        970.0,
        84.21052551269531
      ],
      [
        1250.0,
        970.0,
        98.0
      ],
      [
        1200.0,
        970.0,
        84.21052551269531
      ],
      [
        1200.0,
        1070.0,
        94.73684692382812
      ],
      [
        1231.0,
        1101.0,
        98.0
      ],
      [
        1250.0,
        970.0,
        84.21052551269531
      ],
      [
        1200.0,
        1070.0,
        94.73684692382812
      ],
      [
        1200.0,
        970.0,
        84.21052551269531
      ],
      [
        1200.0,
        970.0,
        98.0
      ],
      [
        1200.0,
        1070.0,
        98.0
      ],
      [
        1480.0,
        880.0,
        98.0
      ],
      [
        1480.0,
        880.0,
        80.0
      ],
      [
        1770.0,
        880.0,
        98.0
      ],
      [
        1770.0,
        880.0,
        80.0
      ],
      [
        1804.7335205078125,
        920.0,
        95.0
      ],
      [
        1804.7335205078125,
        920.0,
        80.0
      ],
      [
        1875.2664794921875,
        920.0,
        95.0
      ],
      [
        1875.2664794921875,
        920.0,
        80.0
      ],
      [
        1250.0,
        920.0,
        80.0
      ],
      [
        1250.0,
        920.0,
        98.0
      ],
      [
        1060.0,
        930.0,
        80.0
      ],
      [
        1060.0,
        930.0,
        98.0
      ],
      [
        1380.0,
        970.0,
        84.21052551269531
      ],
      [
        1380.0,
        930.0,
        80.0
      ],
      [
        1801.7926025390625,
        967.05908203125,
        83.90095520019531
      ],
      [
        1795.8818359375,
        945.0,
        81.57894897460938
      ],
      [
        1884.1181640625,
        945.0,
        81.57894897460938
      ],
      [
        1878.2073974609375,
        967.05908203125,
        83.90095520019531
      ],
      [
        1795.8818359375,
        945.0,
        81.57894897460938
      ],
      [
        1799.901123046875,
        930.0,
        80.0
      ],
      [
        1884.1181640625,
        945.0,
        81.57894897460938
      ],
      [
        1880.098876953125,
        930.0,
        80.0
      ],
      [
        1380.0,
        930.0,
        98.0
      ],
      [
        1770.0,
        930.0,
        95.0
      ],
      [
        1770.0,
        930.0,
        98.0
      ],
      [
        1799.901123046875,
        930.0,
        95.0
      ],
      [
        1880.098876953125,
        930.0,
        95.0
      ],
      [
        1150.0,
        1120.0,
        94.73684692382812
      ],
      [
        1150.0,
        1120.0,
        98.0
      ],
      [
        1010.0,
        980.0,
        80.0
      ],
      [
        1010.0,
        980.0,
        98.0
      ],
      [
        1183.0,
        1153.0,
        98.0
      ],
      [
        1161.3636474609375,
        1131.3636474609375,
        95.45454406738281
      ],
      [
        1150.0,
        1120.0,
        94.73684692382812
      ],
      [
        1161.3636474609375,
        1131.3636474609375,
        95.45454406738281
      ],
      [
        730.0,
        600.0,
        60.0
      ],
      [
        730.0,
        600.0,
        78.0
      ],
      [
        950.0,
        1120.0,
        77.00000762939453
      ],
      [
        905.0,
        1170.0,
        72.5
      ],
      [
        945.5584716796875,
        1310.0,
        76.55585479736328
      ],
      [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      [
        905.0,
        1120.0,
        72.5
      ],
      [
        905.0,
        1170.0,
        72.5
      ],
      [
        873.75,
        1160.0,
        69.375
      ],
      [
        873.75,
        1170.0,
        69.375
      ],
      [
        1680.0,
        2550.0,
        100.0
      ],
      [
        1770.0,
        2550.0,
        100.0
      ],
      [
        1250.0,
        2550.0,
        100.0
      ],
      [
        1360.0,
        2550.0,
        100.0
      ],
      [
        1360.0,
        2550.0,
        100.0
      ],
      [
        1630.0,
        2550.0,
        100.0
      ],
      [
        1680.0,
        2399.999755859375,
        100.0
      ],
      [
        1680.0,
        2395.0,
        100.0
      ],
      [
        1817.94091796875,
        2536.79248046875,
        81.760986328125
      ],
      [
        1804.7335205078125,
        2550.0,
        80.0
      ],
      [
        1680.0,
        2550.0,
        100.0
      ],
      [
        1804.7335205078125,
        2550.0,
        100.0
      ],
      [
        1250.0,
        2550.0,
        100.0
      ],
      [
        1230.0,
        2550.0,
        98.0
      ],
      [
        1250.0,
        2550.0,
        98.0
      ],
      [
        1740.0,
        2729.029052734375,
        67.09709930419922
      ],
      [
        1270.0,
        2729.029052734375,
        67.09709930419922
      ],
      [
        1267.123046875,
        2731.406494140625,
        66.85935974121094
      ],
      [
        1267.4813232421875,
        2731.110107421875,
        66.86129760742188
      ],
      [
        1270.0,
        2729.029052734375,
        67.09709930419922
      ],
      [
        1390.0,
        2652.5,
        74.7500228881836
      ],
      [
        1390.0,
        2652.5,
        74.7500228881836
      ],
      [
        1370.0,
        2668.75,
        73.12503051757812
      ],
      [
        1270.0,
        2750.0,
        65.00000762939453
      ],
      [
        1270.0,
        2750.0,
        65.00000762939453
      ],
      [
        1390.0,
        2652.5,
        74.7500228881836
      ],
      [
        1390.0,
        2652.579345703125,
        74.74208068847656
      ],
      [
        1390.0,
        2652.579345703125,
        74.74208068847656
      ],
      [
        1390.0,
        2652.5,
        74.7500228881836
      ],
      [
        1269.6881103515625,
        2751.091552734375,
        64.8908462524414
      ],
      [
        1269.58935546875,
        2750.333740234375,
        64.96662139892578
      ],
      [
        1269.6881103515625,
        2751.091552734375,
        64.8908462524414
      ],
      [
        1770.0,
        2800.0,
        80.0
      ],
      [
        1270.0,
        2800.0,
        60.422855377197266
      ],
      [
        1270.0,
        2753.487060546875,
        64.65131378173828
      ],
      [
        1270.0,
        2729.029052734375,
        80.0
      ],
      [
        1401.943115234375,
        2620.0,
        80.0
      ],
      [
        1401.943115234375,
        2620.0,
        80.0
      ],
      [
        1270.0,
        2620.0,
        80.0
      ],
      [
        1270.0,
        2620.0,
        80.0
      ],
      [
        1270.0,
        2729.029052734375,
        80.0
      ],
      [
        1608.056884765625,
        2620.0,
        80.0
      ],
      [
        1740.0,
        2729.029052734375,
        80.0
      ],
      [
        1740.0,
        2620.0,
        80.0
      ],
      [
        1608.056884765625,
        2620.0,
        80.0
      ],
      [
        1430.0,
        2620.0,
        80.0
      ],
      [
        1390.0,
        2652.5,
        80.0
      ],
      [
        1390.0,
        2652.5,
        80.0
      ],
      [
        1430.0,
        2620.0,
        80.0
      ],
      [
        1370.0,
        2668.75,
        80.0
      ],
      [
        1270.0,
        2750.0,
        80.0
      ],
      [
        1270.0,
        2800.0,
        70.00000762939453
      ],
      [
        1270.0,
        2750.0,
        72.50001525878906
      ],
      [
        1390.0,
        2690.0,
        75.50003051757812
      ],
      [
        1390.0,
        2652.5,
        77.37500762939453
      ],
      [
        1390.0,
        2652.5,
        77.375
      ],
      [
        1390.0,
        2690.0,
        75.50003051757812
      ],
      [
        1370.0,
        2690.0,
        75.50003051757812
      ],
      [
        1370.0,
        2668.75,
        76.56251525878906
      ],
      [
        1370.0,
        2668.75,
        76.56251525878906
      ],
      [
        1370.0,
        2690.0,
        75.50003051757812
      ],
      [
        1370.0,
        2690.0,
        75.50003051757812
      ],
      [
        1390.0,
        2690.0,
        75.50003051757812
      ],
      [
        1390.0,
        2690.0,
        75.50003051757812
      ],
      [
        1370.0,
        2690.0,
        75.50003051757812
      ],
      [
        1430.0,
        2620.0,
        79.0
      ],
      [
        1460.0,
        2620.0,
        79.0
      ],
      [
        1460.0,
        2620.0,
        79.0
      ],
      [
        1430.0,
        2620.0,
        79.0
      ],
      [
        1550.0,
        2620.0,
        79.0
      ],
      [
        1580.0,
        2620.0,
        79.0
      ],
      [
        1580.0,
        2620.0,
        79.0
      ],
      [
        1550.0,
        2620.0,
        79.0
      ],
      [
        1550.0,
        2620.0,
        79.0
      ],
      [
        1550.0,
        2620.0,
        79.0
      ],
      [
        1460.0,
        2620.0,
        79.0
      ],
      [
        1460.0,
        2620.0,
        79.0
      ],
      [
        1270.0,
        2800.0,
        80.0
      ],
      [
        1270.0,
        2750.0,
        80.0
      ],
      [
        1480.0,
        2640.0,
        80.0
      ],
      [
        1550.0,
        2620.0,
        80.0
      ],
      [
        1580.0,
        2620.0,
        80.0
      ],
      [
        1580.0,
        2620.0,
        80.0
      ],
      [
        1550.0,
        2620.0,
        80.0
      ],
      [
        1550.0,
        2640.0,
        80.0
      ],
      [
        1550.0,
        2620.0,
        80.0
      ],
      [
        1550.0,
        2620.0,
        80.0
      ],
      [
        1550.0,
        2640.0,
        80.0
      ],
      [
        1390.0,
        2652.5,
        80.0
      ],
      [
        1390.0,
        2690.0,
        80.0
      ],
      [
        1390.0,
        2690.0,
        80.0
      ],
      [
        1390.0,
        2652.5,
        80.0
      ],
      [
        1430.0,
        2620.0,
        80.0
      ],
      [
        1460.0,
        2620.0,
        80.0
      ],
      [
        1460.0,
        2620.0,
        80.0
      ],
      [
        1430.0,
        2620.0,
        80.0
      ],
      [
        1460.0,
        2640.0,
        80.0
      ],
      [
        1460.0,
        2620.0,
        80.0
      ],
      [
        1460.0,
        2620.0,
        80.0
      ],
      [
        1460.0,
        2640.0,
        80.0
      ],
      [
        1370.0,
        2668.75,
        80.0
      ],
      [
        1370.0,
        2690.0,
        80.0
      ],
      [
        1370.0,
        2690.0,
        80.0
      ],
      [
        1370.0,
        2668.75,
        80.0
      ],
      [
        1370.0,
        2690.0,
        80.0
      ],
      [
        1390.0,
        2690.0,
        80.0
      ],
      [
        1390.0,
        2690.0,
        80.0
      ],
      [
        1370.0,
        2690.0,
        80.0
      ],
      [
        1770.0,
        2550.0,
        100.0
      ],
      [
        1770.0,
        2600.0,
        100.0
      ],
      [
        1770.0,
        2800.0,
        100.0
      ],
      [
        1770.0,
        2600.0,
        100.0
      ],
      [
        1430.0,
        2620.0,
        98.0
      ],
      [
        1390.0,
        2652.5,
        98.0
      ],
      [
        1390.0,
        2652.5,
        100.0
      ],
      [
        1390.0,
        2652.5,
        100.0
      ],
      [
        1390.0,
        2652.5,
        98.0
      ],
      [
        1430.0,
        2620.0,
        98.0
      ],
      [
        1370.0,
        2668.75,
        100.0
      ],
      [
        1370.0,
        2668.75,
        98.0
      ],
      [
        1270.0,
        2750.0,
        98.0
      ],
      [
        1270.0,
        2750.0,
        100.0
      ],
      [
        1550.0,
        2640.0,
        100.0
      ],
      [
        1460.0,
        2640.0,
        100.0
      ],
      [
        1270.0,
        2800.0,
        98.0
      ],
      [
        1270.0,
        2800.0,
        100.0
      ],
      [
        1270.0,
        2750.0,
        100.0
      ],
      [
        1270.0,
        2750.0,
        98.0
      ],
      [
        1390.0,
        2652.5,
        100.0
      ],
      [
        1390.0,
        2652.5,
        98.0
      ],
      [
        1390.0,
        2690.0,
        98.0
      ],
      [
        1390.0,
        2690.0,
        100.0
      ],
      [
        1390.0,
        2690.0,
        100.0
      ],
      [
        1390.0,
        2690.0,
        98.0
      ],
      [
        1390.0,
        2652.5,
        98.0
      ],
      [
        1390.0,
        2652.5,
        100.0
      ],
      [
        1620.0,
        2690.0,
        98.0
      ],
      [
        1620.0,
        2690.0,
        100.0
      ],
      [
        1620.0,
        2652.5,
        100.0
      ],
      [
        1620.0,
        2652.5,
        98.0
      ],
      [
        1604.6153564453125,
        2640.0,
        98.0
      ],
      [
        1620.0,
        2652.5,
        98.0
      ],
      [
        1620.0,
        2652.5,
        100.0
      ],
      [
        1604.6153564453125,
        2640.0,
        100.0
      ],
      [
        1370.0,
        2690.0,
        100.0
      ],
      [
        1370.0,
        2690.0,
        98.0
      ],
      [
        1370.0,
        2668.75,
        98.0
      ],
      [
        1370.0,
        2668.75,
        100.0
      ],
      [
        1370.0,
        2668.75,
        100.0
      ],
      [
        1370.0,
        2668.75,
        98.0
      ],
      [
        1370.0,
        2690.0,
        98.0
      ],
      [
        1370.0,
        2690.0,
        100.0
      ],
      [
        1370.0,
        2690.0,
        98.0
      ],
      [
        1370.0,
        2690.0,
        100.0
      ],
      [
        1390.0,
        2690.0,
        100.0
      ],
      [
        1390.0,
        2690.0,
        98.0
      ],
      [
        1390.0,
        2690.0,
        98.0
      ],
      [
        1390.0,
        2690.0,
        100.0
      ],
      [
        1370.0,
        2690.0,
        100.0
      ],
      [
        1370.0,
        2690.0,
        98.0
      ],
      [
        1486.0,
        2640.0,
        98.0
      ],
      [
        1486.0,
        2600.0,
        98.0
      ],
      [
        1580.0,
        2620.0,
        100.0
      ],
      [
        1580.0,
        2620.0,
        98.0
      ],
      [
        1641.4000244140625,
        2590.0,
        100.0
      ],
      [
        1641.4000244140625,
        2600.0,
        100.0
      ],
      [
        1550.0,
        2620.0,
        98.0
      ],
      [
        1550.0,
        2620.0,
        100.0
      ],
      [
        1580.0,
        2620.0,
        100.0
      ],
      [
        1580.0,
        2620.0,
        98.0
      ],
      [
        1580.0,
        2620.0,
        98.0
      ],
      [
        1580.0,
        2620.0,
        100.0
      ],
      [
        1550.0,
        2620.0,
        100.0
      ],
      [
        1550.0,
        2620.0,
        98.0
      ],
      [
        1550.0,
        2640.0,
        98.0
      ],
      [
        1550.0,
        2620.0,
        98.0
      ],
      [
        1550.0,
        2620.0,
        98.0
      ],
      [
        1550.0,
        2640.0,
        98.0
      ],
      [
        1486.0,
        2600.0,
        98.0
      ],
      [
        1524.0,
        2600.0,
        98.0
      ],
      [
        1430.0,
        2620.0,
        98.0
      ],
      [
        1460.0,
        2620.0,
        98.0
      ],
      [
        1460.0,
        2620.0,
        98.0
      ],
      [
        1430.0,
        2620.0,
        98.0
      ],
      [
        1460.0,
        2640.0,
        98.0
      ],
      [
        1460.0,
        2620.0,
        98.0
      ],
      [
        1460.0,
        2620.0,
        98.0
      ],
      [
        1460.0,
        2640.0,
        98.0
      ],
      [
        1218.0,
        2640.0,
        100.0
      ],
      [
        1218.0,
        2660.0,
        100.0
      ],
      [
        1334.0,
        2590.0,
        100.0
      ],
      [
        1334.0,
        2580.0,
        100.0
      ],
      [
        1450.349853515625,
        2580.0,
        83.88118743896484
      ],
      [
        1440.0,
        2588.55224609375,
        80.0
      ],
      [
        1559.650390625,
        2580.0,
        82.93986511230469
      ],
      [
        1567.0,
        2586.0732421875,
        80.0
      ],
      [
        1530.7691650390625,
        2580.0,
        94.49234008789062
      ],
      [
        1543.07666015625,
        2590.0,
        89.56932067871094
      ],
      [
        1480.0,
        2640.0,
        80.0
      ],
      [
        1482.0,
        2640.0,
        94.00016021728516
      ],
      [
        1480.0,
        2640.0,
        92.00003051757812
      ],
      [
        1482.0,
        2600.0,
        94.0
      ],
      [
        1528.0,
        2580.0,
        95.60000610351562
      ],
      [
        1528.0,
        2590.0,
        95.5999984741211
      ],
      [
        1528.0,
        2600.0,
        94.0
      ],
      [
        1525.3333740234375,
        2600.0,
        96.66666412353516
      ],
      [
        1522.0,
        2600.0,
        98.0
      ],
      [
        1484.7999267578125,
        2580.0,
        96.79998779296875
      ],
      [
        1484.7999267578125,
        2590.0,
        96.79998779296875
      ],
      [
        1480.0,
        2580.0,
        95.0
      ],
      [
        1480.0,
        2590.0,
        95.0
      ],
      [
        1482.0,
        2640.0,
        95.7499771118164
      ],
      [
        1480.0,
        2640.0,
        98.0
      ],
      [
        1480.0,
        2640.0,
        95.00001525878906
      ],
      [
        1479.231201171875,
        2580.0,
        94.71170043945312
      ],
      [
        1466.9234619140625,
        2590.0,
        90.0962905883789
      ],
      [
        1680.0,
        2400.0,
        140.0
      ],
      [
        1680.0,
        2400.0,
        100.0
      ],
      [
        1665.0,
        2550.0,
        118.0
      ],
      [
        1645.0,
        2550.0,
        118.0
      ],
      [
        1604.6153564453125,
        2640.0,
        140.0
      ],
      [
        1604.6153564453125,
        2640.0,
        100.0
      ],
      [
        1536.4451904296875,
        2620.0,
        100.0
      ],
      [
        1536.4451904296875,
        2620.0,
        118.0
      ],
      [
        1473.5548095703125,
        2620.0,
        118.0
      ],
      [
        1473.5548095703125,
        2620.0,
        100.0
      ],
      [
        1530.0,
        1900.0,
        210.0
      ],
      [
        1530.0,
        1900.0,
        120.0
      ],
      [
        1210.0,
        1900.0,
        118.0
      ],
      [
        1230.0,
        1900.0,
        118.0
      ],
      [
        1300.0,
        2350.0,
        104.34782409667969
      ],
      [
        1500.0,
        2350.0,
        121.73912811279297
      ],
      [
        1530.0,
        1900.0,
        124.34782409667969
      ],
      [
        1530.0,
        2011.986328125,
        124.34783172607422
      ],
      [
        1315.883056640625,
        2334.116943359375,
        105.72896575927734
      ],
      [
        1300.0,
        2350.0,
        104.34782409667969
      ],
      [
        1500.0,
        2400.0,
        121.73912811279297
      ],
      [
        1500.0,
        2350.0,
        121.73912811279297
      ],
      [
        1680.0,
        2395.0,
        137.3913116455078
      ],
      [
        1680.0,
        2400.0,
        137.3913116455078
      ],
      [
        1390.5555419921875,
        2360.0,
        112.22222900390625
      ],
      [
        1390.5555419921875,
        2370.0,
        112.22222900390625
      ],
      [
        1530.0,
        1950.0,
        210.0
      ],
      [
        1530.0,
        1950.0,
        124.34782409667969
      ],
      [
        1300.0,
        2350.0,
        135.0
      ],
      [
        1249.9998779296875,
        2300.0,
        142.0
      ],
      [
        1249.9998779296875,
        2300.0,
        135.0
      ],
      [
        1249.9998779296875,
        2326.431640625,
        136.63165283203125
      ],
      [
        1249.9998779296875,
        2321.664794921875,
        135.0
      ],
      [
        1254.7001953125,
        2316.964599609375,
        135.0
      ],
      [
        1249.9998779296875,
        2299.958984375,
        125.0
      ],
      [
        1249.9998779296875,
        2299.958984375,
        100.00178527832031
      ],
      [
        1249.9998779296875,
        2300.0,
        125.01398468017578
      ],
      [
        1249.9998779296875,
        2299.958984375,
        125.0
      ],
      [
        1249.9998779296875,
        2300.0,
        125.01398468017578
      ],
      [
        1249.9998779296875,
        2312.2138671875,
        131.76498413085938
      ],
      [
        1289.5999755859375,
        2380.0,
        118.0
      ],
      [
        1289.5999755859375,
        2390.0,
        118.0
      ],
      [
        1200.0,
        2040.0,
        118.0
      ],
      [
        1200.0,
        2020.0,
        118.0
      ],
      [
        1210.0,
        1950.0,
        118.0
      ],
      [
        1230.0,
        1950.0,
        118.0
      ],
      [
        1249.9998779296875,
        2239.949462890625,
        118.0
      ],
      [
        1249.9793701171875,
        2299.9794921875,
        118.0
      ],
      [
        1249.9793701171875,
        2299.9794921875,
        118.0
      ],
      [
        1249.9998779296875,
        2299.958984375,
        118.0
      ],
      [
        1249.9703369140625,
        2326.40185546875,
        136.611328125
      ],
      [
        1249.9752197265625,
        2312.18896484375,
        131.74801635742188
      ],
      [
        1200.0,
        1910.0,
        118.0
      ],
      [
        1200.0,
        1930.0,
        118.0
      ],
      [
        980.0,
        2185.0,
        140.0
      ],
      [
        1070.0,
        1900.0,
        84.70587921142578
      ],
      [
        1180.0,
        1900.0,
        97.64705657958984
      ],
      [
        1180.0,
        1900.0,
        160.0
      ],
      [
        1070.0,
        1900.0,
        160.0
      ],
      [
        1070.0,
        1950.0,
        84.70587921142578
      ],
      [
        1180.0,
        1950.0,
        97.64705657958984
      ],
      [
        1180.0,
        1900.0,
        97.64705657958984
      ],
      [
        1070.0,
        1900.0,
        84.70587921142578
      ],
      [
        1180.0,
        1950.0,
        97.64705657958984
      ],
      [
        1070.0,
        1950.0,
        80.0
      ],
      [
        1070.0,
        1950.0,
        84.70587921142578
      ],
      [
        1140.8695068359375,
        2300.0,
        93.0434799194336
      ],
      [
        1070.0,
        2300.0,
        84.70587921142578
      ],
      [
        1070.0,
        2300.0,
        80.0
      ],
      [
        1120.0,
        2200.0,
        90.58824157714844
      ],
      [
        1180.0,
        2200.0,
        97.64705657958984
      ],
      [
        1140.8695068359375,
        2280.0,
        93.0434799194336
      ],
      [
        1140.8695068359375,
        2300.0,
        93.0434799194336
      ],
      [
        1140.8695068359375,
        2280.0,
        93.0434799194336
      ],
      [
        1180.0,
        2280.0,
        97.64705657958984
      ],
      [
        1120.0,
        2140.0,
        90.58824157714844
      ],
      [
        1180.0,
        2140.0,
        97.64704895019531
      ],
      [
        1120.0,
        2140.0,
        90.58824157714844
      ],
      [
        1120.0,
        2200.0,
        90.58824157714844
      ],
      [
        1180.0,
        2350.0,
        96.80000305175781
      ],
      [
        1180.0,
        2400.0,
        96.80000305175781
      ],
      [
        1120.0,
        2331.0,
        87.20000457763672
      ],
      [
        1074.9998779296875,
        2331.0,
        80.0
      ],
      [
        1180.0,
        2331.0,
        80.0
      ],
      [
        1120.0,
        2331.0,
        87.20000457763672
      ],
      [
        1180.0,
        2331.0,
        96.80000305175781
      ],
      [
        1171.0,
        2357.0,
        95.36000061035156
      ],
      [
        1180.0,
        2357.0,
        96.80001068115234
      ],
      [
        1120.0,
        2400.0,
        90.5882339477539
      ],
      [
        1133.8988037109375,
        2400.0,
        92.223388671875
      ],
      [
        1133.8988037109375,
        2400.0,
        92.223388671875
      ],
      [
        1180.0,
        2400.0,
        97.64704895019531
      ],
      [
        1180.0,
        2400.0,
        96.80000305175781
      ],
      [
        1180.0,
        2350.0,
        96.80000305175781
      ],
      [
        1180.0,
        2350.0,
        97.64704895019531
      ],
      [
        1120.0,
        2350.0,
        90.5882339477539
      ],
      [
        1120.0,
        2331.0,
        90.58824157714844
      ],
      [
        1070.0,
        2331.0,
        80.0
      ],
      [
        1070.0,
        2331.0,
        84.70587921142578
      ],
      [
        1120.0,
        2331.0,
        90.58824157714844
      ],
      [
        1180.0,
        2331.0,
        97.64705657958984
      ],
      [
        1120.0,
        2400.0,
        90.5882339477539
      ],
      [
        1120.0,
        2350.0,
        90.5882339477539
      ],
      [
        1171.0,
        2357.0,
        96.58822631835938
      ],
      [
        1180.0,
        2357.0,
        97.64705657958984
      ],
      [
        1070.0,
        2260.0,
        100.0
      ],
      [
        1070.0,
        2260.0,
        140.0
      ],
      [
        1070.0,
        1950.0,
        100.0
      ],
      [
        1180.0,
        1910.0,
        118.0
      ],
      [
        1180.0,
        1930.0,
        118.0
      ],
      [
        1070.0,
        1930.0,
        98.0
      ],
      [
        1070.0,
        1950.0,
        98.0
      ],
      [
        1070.0,
        2331.0,
        140.0
      ],
      [
        1180.0,
        2331.0,
        120.0
      ],
      [
        1180.0,
        2331.0,
        140.0
      ],
      [
        1180.0,
        2331.0,
        105.0
      ],
      [
        1180.0,
        2331.0,
        120.0
      ],
      [
        1180.0,
        2350.0,
        118.74529266357422
      ],
      [
        1120.0,
        2350.0,
        107.50242614746094
      ],
      [
        1120.0,
        2350.0,
        107.50242614746094
      ],
      [
        1120.0,
        2331.0,
        107.73252868652344
      ],
      [
        1180.0,
        2350.0,
        118.26090240478516
      ],
      [
        1120.0,
        2350.0,
        107.38323974609375
      ],
      [
        1120.0,
        2350.0,
        107.38323974609375
      ],
      [
        1120.0,
        2331.0,
        107.38323974609375
      ],
      [
        1180.0,
        2331.0,
        105.0
      ],
      [
        1180.0,
        2350.0,
        105.0
      ],
      [
        1137.5,
        2400.0,
        105.0
      ],
      [
        1120.0,
        2394.65771484375,
        105.0
      ],
      [
        1120.0,
        2355.31787109375,
        105.0
      ],
      [
        1120.0,
        2355.60107421875,
        105.0
      ],
      [
        1137.5074462890625,
        2350.0,
        105.0
      ],
      [
        1171.0,
        2357.0,
        105.0
      ],
      [
        1180.0,
        2357.0,
        105.0
      ],
      [
        1142.134765625,
        2350.0,
        105.0
      ],
      [
        1142.134765625,
        2350.0,
        105.0
      ],
      [
        1120.0,
        2358.044677734375,
        106.22245788574219
      ],
      [
        1120.0,
        2355.60107421875,
        105.0
      ],
      [
        1120.0,
        2356.152587890625,
        105.0
      ],
      [
        1070.0,
        2300.0,
        100.0
      ],
      [
        1070.0,
        2300.0,
        100.0
      ],
      [
        1070.0,
        2260.0,
        100.0
      ],
      [
        1190.0,
        2107.199951171875,
        98.39999389648438
      ],
      [
        1190.0,
        2104.0,
        98.39999389648438
      ],
      [
        1187.5,
        2104.0,
        98.0
      ],
      [
        1190.0,
        2257.199951171875,
        98.39999389648438
      ],
      [
        1180.0,
        2331.0,
        96.80000305175781
      ],
      [
        1200.0,
        2331.0,
        100.0
      ],
      [
        1187.5,
        2280.0,
        98.0
      ],
      [
        1187.5,
        2260.0,
        98.0
      ],
      [
        1190.0,
        2260.0,
        98.39999389648438
      ],
      [
        1180.0,
        2331.0,
        97.64704895019531
      ],
      [
        1180.0,
        2350.0,
        97.64704895019531
      ],
      [
        1180.0,
        2400.0,
        97.64704895019531
      ],
      [
        1183.0001220703125,
        2280.0,
        98.0
      ],
      [
        1190.0,
        2106.35302734375,
        98.82351684570312
      ],
      [
        1190.0,
        2104.0,
        98.82351684570312
      ],
      [
        1183.0001220703125,
        2104.0,
        98.0
      ],
      [
        1190.0,
        2257.941162109375,
        98.82351684570312
      ],
      [
        1183.0001220703125,
        2260.0,
        98.0
      ],
      [
        1190.0,
        2260.0,
        98.82351684570312
      ],
      [
        1070.0,
        1950.0,
        84.70587921142578
      ],
      [
        1061.3636474609375,
        2300.0,
        83.6898422241211
      ],
      [
        1070.0,
        2300.0,
        84.70587921142578
      ],
      [
        1070.0,
        2331.0,
        84.70587921142578
      ],
      [
        1069.8182373046875,
        2331.0,
        84.68449401855469
      ],
      [
        1030.0,
        2185.0,
        98.0
      ],
      [
        980.0,
        2185.0,
        98.0
      ],
      [
        1010.0,
        2177.800048828125,
        98.0
      ],
      [
        1020.0,
        2177.800048828125,
        98.0
      ],
      [
        1010.0,
        2177.800048828125,
        98.0
      ],
      [
        990.0,
        1904.199951171875,
        98.0
      ],
      [
        980.0,
        1904.199951171875,
        98.0
      ],
      [
        990.0,
        1904.199951171875,
        98.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -370.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        1990.0,
        2850.0,
        317.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -370.0,
        1110.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1480.0,
        100.0
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        260.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        260.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 107.33126068115234,
      "bbox_min": [
        400.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1425.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -332.8201599121094,
      "bbox_min": [
        450.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1830.0,
      "bbox_min": [
        500.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        1990.0,
        2850.0,
        317.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        500.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        1990.0,
        1830.0,
        160.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        500.0,
        520.0,
        78.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        500.0,
        520.0,
        78.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        500.0,
        700.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        500.0,
        1400.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        500.0,
        1400.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -295.1610107421875,
      "bbox_min": [
        500.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        504.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        500.0,
        930.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        500.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        500.0,
        930.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        780.0,
        750.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        78.0
      ],
      "bbox_max": [
        960.0,
        1280.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        930.0,
        78.0
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043035984039307,
        0.0,
        0.9938838481903076
      ],
      "plane_d": 26.50244140625,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        950.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        942.0,
        930.0,
        78.0
      ],
      "bbox_max": [
        960.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        780.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        891.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 328.7020263671875,
      "bbox_min": [
        891.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        895.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 527.358154296875,
      "bbox_min": [
        893.1818237304688,
        1120.0,
        78.0
      ],
      "bbox_max": [
        895.0,
        1130.0,
        79.09090423583984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 527.358154296875,
      "bbox_min": [
        891.6666870117188,
        1120.0,
        79.09090423583984
      ],
      "bbox_max": [
        893.1818237304688,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        780.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1570.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950361400842667,
        0.0,
        0.9950371980667114
      ],
      "plane_d": 17.910568237304688,
      "bbox_min": [
        780.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.6736147403717041,
        -0.7390826940536499,
        0.0
      ],
      "plane_d": 501.24530029296875,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1553.1624755859375,
        78.0
      ],
      "bbox_max": [
        960.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1553.1624755859375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        960.0,
        1553.1624755859375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9011393785476685,
        0.4335293471813202,
        -0.0
      ],
      "plane_d": -1405.2288818359375,
      "bbox_min": [
        820.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        820.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        832.5558471679688,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736146807670593,
        0.7390826344490051,
        -0.0
      ],
      "plane_d": -1605.140380859375,
      "bbox_min": [
        893.5803833007812,
        1300.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9898995161056519,
        0.14177139103412628,
        0.0
      ],
      "plane_d": -1083.03466796875,
      "bbox_min": [
        893.5803833007812,
        1300.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -150.27244567871094,
      "bbox_min": [
        820.0,
        1404.0,
        78.0
      ],
      "bbox_max": [
        827.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1530.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        650.0,
        520.0,
        78.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        780.0,
        650.0,
        78.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        780.0,
        650.0,
        78.0
      ],
      "bbox_max": [
        900.0,
        650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1480.0,
        720.0,
        78.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": 11.940444946289062,
      "bbox_min": [
        1480.0,
        900.0,
        78.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        686.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        689.9500122070312,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        500.0,
        520.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        1830.0,
        160.0
      ],
      "face_count": 19
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        500.0,
        700.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        500.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        500.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        579.4630737304688,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        579.4630737304688,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1220.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        579.4630737304688,
        1170.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1280.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877845883369446,
        -0.8090174794197083,
        0.0
      ],
      "plane_d": 568.728515625,
      "bbox_min": [
        579.4630737304688,
        1175.6285400390625,
        118.0
      ],
      "bbox_max": [
        728.3754272460938,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1175.6285400390625,
      "bbox_min": [
        579.4630737304688,
        1175.6285400390625,
        118.0
      ],
      "bbox_max": [
        728.3754272460938,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        -0.30901724100112915,
        0.0
      ],
      "plane_d": -297.18408203125,
      "bbox_min": [
        708.0369262695312,
        1217.4046630859375,
        118.0
      ],
      "bbox_max": [
        728.3754272460938,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        118.0
      ],
      "bbox_max": [
        730.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        0.30901724100112915,
        -0.0
      ],
      "plane_d": -1091.3583984375,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        118.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877845883369446,
        0.8090174794197083,
        -0.0
      ],
      "plane_d": -1510.446533203125,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        118.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1394.3714599609375,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        118.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        -0.30901724100112915,
        0.0
      ],
      "plane_d": -297.18408203125,
      "bbox_min": [
        728.3754272460938,
        1280.0,
        118.0
      ],
      "bbox_max": [
        730.0,
        1285.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        896.850830078125,
        1280.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        896.850830078125,
        1280.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1570.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        980.0,
        1280.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        980.0,
        1280.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1280.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1280.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        896.850830078125,
        1300.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        896.850830078125,
        1300.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1540.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1325.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1375.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1375.0,
      "bbox_min": [
        1200.0,
        1375.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1375.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        896.850830078125,
        1310.0,
        118.0
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1459.9998779296875,
      "bbox_min": [
        1050.0,
        1375.0,
        118.0
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1050.0,
        1460.0,
        118.0
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        1050.0,
        1525.0,
        118.0
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1525.0,
        118.0
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1460.0,
        118.0
      ],
      "bbox_max": [
        1070.0,
        1475.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1050.0,
        1375.0,
        118.0
      ],
      "bbox_max": [
        1090.0,
        1390.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        1050.0,
        1375.0,
        118.0
      ],
      "bbox_max": [
        1070.0,
        1390.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1375.0,
        118.0
      ],
      "bbox_max": [
        1070.0,
        1390.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9011393785476685,
        0.4335293471813202,
        -0.0
      ],
      "plane_d": -1405.2288818359375,
      "bbox_min": [
        896.850830078125,
        1310.0,
        118.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.901139497756958,
        -0.4335293769836426,
        0.0
      ],
      "plane_d": -169.67022705078125,
      "bbox_min": [
        896.850830078125,
        1310.0,
        118.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736146807670593,
        0.7390826344490051,
        -0.0
      ],
      "plane_d": -1605.140380859375,
      "bbox_min": [
        916.3604125976562,
        1310.0,
        118.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736147403717041,
        -0.7390826940536499,
        0.0
      ],
      "plane_d": 501.24530029296875,
      "bbox_min": [
        916.3604125976562,
        1513.3883056640625,
        118.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        960.0,
        1550.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1550.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        940.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        940.0,
        1620.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -979.9999389648438,
      "bbox_min": [
        940.0,
        1620.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        940.0,
        1620.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1646.0,
        118.0
      ],
      "bbox_max": [
        940.0,
        1650.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1647.5,
      "bbox_min": [
        962.5,
        1642.5,
        118.0
      ],
      "bbox_max": [
        967.5,
        1647.5,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -967.5,
      "bbox_min": [
        967.5,
        1642.5,
        118.0
      ],
      "bbox_max": [
        967.5,
        1647.5,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        940.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        940.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1620.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -979.9999389648438,
      "bbox_min": [
        940.0,
        1570.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1614.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1610.0,
        118.0
      ],
      "bbox_max": [
        940.0,
        1614.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1612.5,
      "bbox_min": [
        940.0,
        1612.5,
        118.0
      ],
      "bbox_max": [
        967.5,
        1620.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -967.5,
      "bbox_min": [
        940.0,
        1612.5,
        118.0
      ],
      "bbox_max": [
        967.5,
        1620.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1617.5,
      "bbox_min": [
        940.0,
        1614.0,
        118.0
      ],
      "bbox_max": [
        967.5,
        1620.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1614.0,
        118.0
      ],
      "bbox_max": [
        940.0,
        1617.5,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1617.5,
        118.0
      ],
      "bbox_max": [
        940.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1280.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1630.0,
      "bbox_min": [
        1630.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1630.0,
        1170.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1630.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1630.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1630.0,
        1377.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1280.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2071.822998046875,
      "bbox_min": [
        1480.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1457.0,
        1377.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2071.822998046875,
      "bbox_min": [
        1480.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        500.0,
        700.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        1010.0,
        720.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1200.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1200.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1111.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1630.0,
      "bbox_min": [
        1630.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1111.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1030.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1101.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1070.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1250.0,
        1100.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1250.0,
        1100.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1630.0,
      "bbox_min": [
        1250.0,
        1100.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1660.0,
        1101.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1110.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1250.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1250.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1535.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1660.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1535.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1535.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1454.9998779296875,
      "bbox_min": [
        1250.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1250.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        130.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        130.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1290.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1455.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1680.0,
        1130.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1455.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1555.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1555.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1454.9998779296875,
      "bbox_min": [
        1455.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1455.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1680.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1555.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1680.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1120.0,
        130.00003051757812
      ],
      "bbox_max": [
        1680.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1454.9998779296875,
      "bbox_min": [
        1455.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1455.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1290.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1290.0,
        1128.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": 709.2808227539062,
      "bbox_min": [
        1310.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1617.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1617.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1657.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1617.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 491.9349670410156,
      "bbox_min": [
        1336.0,
        1150.0,
        118.0
      ],
      "bbox_max": [
        1340.0,
        1160.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1010.0,
        720.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        720.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        880.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1600.0,
        810.0,
        118.0
      ],
      "bbox_max": [
        1750.0,
        880.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1600.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1600.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1600.0,
        840.0,
        118.0
      ],
      "bbox_max": [
        1600.0,
        880.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1200.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        970.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        970.0,
        124.21052551269531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1250.0,
        880.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1250.0,
        880.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1250.0,
        880.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        880.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        880.0,
        118.00000762939453
      ],
      "bbox_max": [
        1770.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1250.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        500.0,
        700.0,
        118.0
      ],
      "bbox_max": [
        1300.0,
        1170.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        500.0,
        700.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        500.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        730.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1070.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        730.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        730.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1010.0,
        970.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        905.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1300.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        905.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1300.0,
        1170.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        500.0,
        520.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        1830.0,
        118.00000762939453
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        500.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1830.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        500.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1830.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        935.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1065.6220703125,
        1830.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071017026901245,
        0.7071118354797363,
        -0.0
      ],
      "plane_d": -1887.5390625,
      "bbox_min": [
        935.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1065.6220703125,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071000337600708,
        0.70711350440979,
        0.0
      ],
      "plane_d": -466.269287109375,
      "bbox_min": [
        935.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1065.6220703125,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071000337600708,
        -0.70711350440979,
        0.0
      ],
      "plane_d": 2022.770263671875,
      "bbox_min": [
        935.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1065.6220703125,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071000337600708,
        -0.70711350440979,
        0.0
      ],
      "plane_d": 601.4992065429688,
      "bbox_min": [
        935.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659281373023987,
        -0.25881069898605347,
        0.0
      ],
      "plane_d": -447.635986328125,
      "bbox_min": [
        935.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659281373023987,
        0.25881069898605347,
        -0.0
      ],
      "plane_d": -1358.649658203125,
      "bbox_min": [
        935.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588212490081787,
        0.9659253358840942,
        0.0
      ],
      "plane_d": -1482.528076171875,
      "bbox_min": [
        960.8818359375,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588212490081787,
        -0.9659253358840942,
        0.0
      ],
      "plane_d": 1397.29833984375,
      "bbox_min": [
        960.8818359375,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1804.1181640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659266471862793,
        -0.25881627202033997,
        0.0
      ],
      "plane_d": 1383.6580810546875,
      "bbox_min": [
        960.8818359375,
        1715.8818359375,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1804.1181640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659266471862793,
        0.25881627202033997,
        -1.5796891830177628e-06
      ],
      "plane_d": 472.6248474121094,
      "bbox_min": [
        960.8818359375,
        1715.8818359375,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1804.1181640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588212490081787,
        -0.9659253358840942,
        0.0
      ],
      "plane_d": 1917.529052734375,
      "bbox_min": [
        966.79248046875,
        1715.8818359375,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1804.1181640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588212490081787,
        0.9659253358840942,
        -0.0
      ],
      "plane_d": -2002.7587890625,
      "bbox_min": [
        966.79248046875,
        1721.7926025390625,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1804.1181640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071041464805603,
        -0.7071094512939453,
        0.0
      ],
      "plane_d": 491.258056640625,
      "bbox_min": [
        966.79248046875,
        1721.7926025390625,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1798.2073974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071041464805603,
        0.7071094512939453,
        -0.0
      ],
      "plane_d": -1997.76708984375,
      "bbox_min": [
        966.79248046875,
        1721.7926025390625,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1798.2073974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071041464805603,
        -0.7071094512939453,
        -4.315853857406182e-06
      ],
      "plane_d": 1912.537841796875,
      "bbox_min": [
        966.79248046875,
        1721.7926025390625,
        80.0
      ],
      "bbox_max": [
        982.94091796875,
        1798.2073974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071041464805603,
        0.7071094512939453,
        0.0
      ],
      "plane_d": -576.4878540039062,
      "bbox_min": [
        966.79248046875,
        1782.05908203125,
        80.0
      ],
      "bbox_max": [
        982.94091796875,
        1798.2073974609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588256597518921,
        0.9659240245819092,
        -5.895532467548037e-06
      ],
      "plane_d": -1892.5306396484375,
      "bbox_min": [
        970.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1699.3782958984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1696.69873046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1696.69873046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588256597518921,
        -0.9659240245819092,
        0.0
      ],
      "plane_d": 2027.760986328125,
      "bbox_min": [
        970.0,
        1820.6217041015625,
        80.0
      ],
      "bbox_max": [
        1040.0,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1823.30126953125,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588256597518921,
        -0.9659240245819092,
        0.0
      ],
      "plane_d": 1507.5213623046875,
      "bbox_min": [
        970.0,
        1820.6217041015625,
        80.0
      ],
      "bbox_max": [
        980.0,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1823.30126953125,
        80.0
      ],
      "bbox_max": [
        980.0,
        1830.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        615.62841796875,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        615.62841796875,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        780.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1280.0,
        109.56521606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1280.0,
        109.56521606445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1270.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1280.0,
        100.43478393554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        780.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1280.0,
        90.86956787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1229.9998779296875,
        80.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        82.17391967773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        615.62841796875,
        1280.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1690.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        615.62841796875,
        1281.22607421875,
        80.0
      ],
      "bbox_max": [
        730.0,
        1670.0,
        96.95652770996094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        685.0,
        1670.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1670.0,
        96.95652770996094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        0.30901724100112915,
        -0.0
      ],
      "plane_d": -1091.3583984375,
      "bbox_min": [
        615.62841796875,
        1281.22607421875,
        80.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        82.20140838623047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877845883369446,
        0.8090174794197083,
        -0.0
      ],
      "plane_d": -1510.446533203125,
      "bbox_min": [
        615.62841796875,
        1281.22607421875,
        80.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        82.20140838623047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1394.3714599609375,
      "bbox_min": [
        615.62841796875,
        1281.22607421875,
        80.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        81.51776123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        -0.30901724100112915,
        0.0
      ],
      "plane_d": -297.18408203125,
      "bbox_min": [
        728.7738037109375,
        1281.22607421875,
        80.0
      ],
      "bbox_max": [
        730.0,
        1285.0,
        80.21739959716797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        734.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1690.0,
        118.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1200.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1380.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1200.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1375.0,
        105.88235473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1375.0,
      "bbox_min": [
        1200.0,
        1375.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1375.0,
        105.88235473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        734.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        115.21739196777344
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        734.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        110.86956024169922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        734.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        108.69564819335938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        734.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        107.82609558105469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1647.5,
      "bbox_min": [
        962.5,
        1642.5,
        100.0
      ],
      "bbox_max": [
        967.5,
        1647.5,
        106.30435180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -967.5,
      "bbox_min": [
        962.5,
        1642.5,
        100.0
      ],
      "bbox_max": [
        967.5,
        1647.5,
        106.30435180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1642.5,
      "bbox_min": [
        962.5,
        1642.5,
        100.0
      ],
      "bbox_max": [
        967.5,
        1642.5,
        106.08695983886719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        734.0,
        1643.9998779296875,
        98.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        780.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        115.21739196777344
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1620.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.8574929237365723,
        0.0
      ],
      "plane_d": -1867.6195068359375,
      "bbox_min": [
        940.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1620.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1614.0,
        103.65216827392578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -967.5,
      "bbox_min": [
        962.5,
        1612.5,
        100.0
      ],
      "bbox_max": [
        967.5,
        1617.5,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1612.5,
      "bbox_min": [
        962.5,
        1612.5,
        100.0
      ],
      "bbox_max": [
        967.5,
        1612.5,
        104.78260803222656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        980.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        115.21739196777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        980.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        1017.3964233398438,
        1620.0,
        107.27810668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1017.3964233398438,
        1620.0,
        107.27810668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        780.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1570.0,
        110.86956787109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        980.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        101.3043441772461
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        780.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1570.0,
        110.86956787109375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        914.4931030273438,
        1325.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1570.0,
        110.86956787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        914.4931030273438,
        1325.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1540.0,
        106.73912811279297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1375.0,
      "bbox_min": [
        1200.0,
        1325.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1375.0,
        106.73912811279297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1355.294189453125,
        105.88235473632812
      ],
      "bbox_max": [
        1250.0,
        1375.0,
        106.73912811279297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        914.4931030273438,
        1374.0001220703125,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        106.08695983886719
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1459.9998779296875,
      "bbox_min": [
        1050.0,
        1375.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1475.0,
        103.47825622558594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1050.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1475.0,
        103.26087188720703
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1475.0,
        103.26087188720703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1050.0,
        1375.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1390.0,
        100.43478393554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        1050.0,
        1375.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1390.0,
        99.56521606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1375.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1390.0,
        99.56521606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1525.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        106.08695983886719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736147403717041,
        -0.7390826940536499,
        0.0
      ],
      "plane_d": 501.24530029296875,
      "bbox_min": [
        914.4931030273438,
        1509.5068359375,
        98.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        100.67645263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.901139497756958,
        -0.4335293769836426,
        0.0
      ],
      "plane_d": -169.67022705078125,
      "bbox_min": [
        914.4931030273438,
        1509.5068359375,
        98.0
      ],
      "bbox_max": [
        916.3604125976562,
        1513.3883056640625,
        98.24994659423828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        960.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        105.65217590332031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        960.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        103.47826385498047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        102.60870361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        102.60868835449219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        780.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1050.0,
        1450.0,
        82.35293579101562
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        1050.0,
        1525.0,
        82.35293579101562
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1525.0,
        84.70588684082031
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1459.9998779296875,
      "bbox_min": [
        1070.0,
        1450.0,
        84.70588684082031
      ],
      "bbox_max": [
        1090.0,
        1475.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1460.0,
        84.70588684082031
      ],
      "bbox_max": [
        1070.0,
        1475.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1090.0,
        1450.0,
        87.05882263183594
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.901139497756958,
        -0.4335293769836426,
        0.0
      ],
      "plane_d": -169.67022705078125,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9898993968963623,
        -0.14177139103412628,
        0.0
      ],
      "plane_d": -678.9862060546875,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        80.0
      ],
      "bbox_max": [
        896.850830078125,
        1472.83544921875,
        95.63854217529297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        832.5558471679688,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1070.0,
        1375.0,
        84.70588684082031
      ],
      "bbox_max": [
        1090.0,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1375.0,
        84.70588684082031
      ],
      "bbox_max": [
        1070.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1090.0,
        1390.0,
        87.05882263183594
      ],
      "bbox_max": [
        1090.0,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        832.5558471679688,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1400.0,
        96.85714721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9898995161056519,
        0.14177139103412628,
        0.0
      ],
      "plane_d": -1083.03466796875,
      "bbox_min": [
        893.5803833007812,
        1364.68896484375,
        89.72048950195312
      ],
      "bbox_max": [
        902.8526611328125,
        1400.0,
        92.32958221435547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9011393785476685,
        0.4335293471813202,
        -0.0
      ],
      "plane_d": -1405.2288818359375,
      "bbox_min": [
        896.850830078125,
        1364.68896484375,
        90.24144744873047
      ],
      "bbox_max": [
        902.8526611328125,
        1377.16455078125,
        91.47893524169922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9011393785476685,
        0.4335293471813202,
        -0.0
      ],
      "plane_d": -1405.2288818359375,
      "bbox_min": [
        893.5803833007812,
        1310.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1400.0,
        96.85714721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": -533.9730834960938,
      "bbox_min": [
        893.5803833007812,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1400.0,
        96.85714721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1386.761962890625,
        96.66667175292969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1386.761962890625,
        96.3809585571289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9898995161056519,
        0.14177139103412628,
        0.0
      ],
      "plane_d": -1083.03466796875,
      "bbox_min": [
        893.5803833007812,
        1377.16455078125,
        80.0
      ],
      "bbox_max": [
        896.850830078125,
        1400.0,
        90.24144744873047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -150.27244567871094,
      "bbox_min": [
        827.0,
        1400.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1090.0,
        1400.0,
        87.05882263183594
      ],
      "bbox_max": [
        1090.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        93.47826385498047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1530.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1540.0,
        93.47826385498047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        84.34783172607422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        83.91304779052734
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1320.0,
        83.91304779052734
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        960.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1630.0,
      "bbox_min": [
        1630.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1377.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1376.9998779296875,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        500.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1690.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1630.0,
      "bbox_min": [
        1630.0,
        1170.0,
        114.34783172607422
      ],
      "bbox_max": [
        1680.0,
        1254.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1170.0,
        116.52174377441406
      ],
      "bbox_max": [
        1680.0,
        1204.0001220703125,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        500.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1457.0,
        1690.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        500.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        118.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        579.4630737304688,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        579.4630737304688,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        579.4630737304688,
        1170.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1175.6285400390625,
      "bbox_min": [
        579.4630737304688,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        728.3754272460938,
        1280.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        -0.30901724100112915,
        0.0
      ],
      "plane_d": -297.18408203125,
      "bbox_min": [
        708.0369262695312,
        1217.4046630859375,
        80.0
      ],
      "bbox_max": [
        728.3754272460938,
        1280.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1000.0,
        1170.0,
        88.26087188720703
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1000.0,
        1170.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 646.6708984375,
      "bbox_min": [
        1020.0,
        1210.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        118.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1670.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        722.40966796875,
        1670.0,
        96.62651062011719
      ],
      "bbox_max": [
        730.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        0.30901724100112915,
        -0.0
      ],
      "plane_d": -1091.3583984375,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877845883369446,
        0.8090174794197083,
        -0.0
      ],
      "plane_d": -1510.446533203125,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1394.3714599609375,
      "bbox_min": [
        579.4630737304688,
        1280.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1394.3714599609375,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564804077148,
        -0.30901724100112915,
        0.0
      ],
      "plane_d": -297.18408203125,
      "bbox_min": [
        728.3754272460938,
        1280.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1285.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        730.0,
        1280.0,
        83.47825622558594
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        118.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        871.0581665039062,
        1280.0,
        86.13297271728516
      ],
      "bbox_max": [
        1250.0,
        1300.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1280.0,
        111.45054626464844
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        90.86956787109375
      ],
      "bbox_max": [
        1250.0,
        1300.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        980.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1300.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        980.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        111.45054626464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        103.48612976074219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1280.0,
        102.60869598388672
      ],
      "bbox_max": [
        1250.0,
        1300.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1280.0,
        90.86956787109375
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1280.0,
        93.04347229003906
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        730.0,
        1300.0,
        83.47825622558594
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        118.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        780.0,
        1300.0,
        83.47825622558594
      ],
      "bbox_max": [
        1250.0,
        1570.0,
        118.00000762939453
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1325.0,
        102.39130401611328
      ],
      "bbox_max": [
        1250.0,
        1375.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1375.0,
      "bbox_min": [
        1200.0,
        1375.0,
        104.56521606445312
      ],
      "bbox_max": [
        1250.0,
        1375.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1050.0,
        1375.0,
        98.91304016113281
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1375.0,
        98.91304016113281
      ],
      "bbox_max": [
        1070.0,
        1390.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1050.0,
        1460.0,
        102.39130401611328
      ],
      "bbox_max": [
        1090.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        1050.0,
        1525.0,
        104.56521606445312
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1525.0,
        105.43478393554688
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1459.9998779296875,
      "bbox_min": [
        1070.0,
        1460.0,
        102.60868835449219
      ],
      "bbox_max": [
        1090.0,
        1475.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1460.0,
        102.60868835449219
      ],
      "bbox_max": [
        1070.0,
        1475.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9011393785476685,
        0.4335293471813202,
        -0.0
      ],
      "plane_d": -1405.2288818359375,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1320.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1530.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1540.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.901139497756958,
        -0.4335293769836426,
        0.0
      ],
      "plane_d": -169.67022705078125,
      "bbox_min": [
        896.850830078125,
        1310.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736147403717041,
        -0.7390826940536499,
        0.0
      ],
      "plane_d": 501.24530029296875,
      "bbox_min": [
        916.3604125976562,
        1386.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1540.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        1000.0,
        1386.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1386.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        101.7391357421875
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1550.0,
        101.7391357421875
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1550.0,
        102.60868835449219
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1550.0,
        104.78260803222656
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1300.0,
        83.47825622558594
      ],
      "bbox_max": [
        1050.0,
        1540.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1300.0,
        87.32898712158203
      ],
      "bbox_max": [
        1050.0,
        1509.5068359375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        878.566650390625,
        1300.0,
        87.32898712158203
      ],
      "bbox_max": [
        1050.0,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9011393785476685,
        0.4335293471813202,
        -0.0
      ],
      "plane_d": -1405.2288818359375,
      "bbox_min": [
        893.5803833007812,
        1310.0,
        91.19747161865234
      ],
      "bbox_max": [
        945.5584716796875,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736146807670593,
        0.7390826344490051,
        -0.0
      ],
      "plane_d": -1605.140380859375,
      "bbox_min": [
        893.5803833007812,
        1310.0,
        91.47893524169922
      ],
      "bbox_max": [
        945.5584716796875,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9898995161056519,
        0.14177139103412628,
        0.0
      ],
      "plane_d": -1083.03466796875,
      "bbox_min": [
        893.5803833007812,
        1377.16455078125,
        91.47893524169922
      ],
      "bbox_max": [
        896.850830078125,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        902.8526611328125,
        1310.0,
        90.56400299072266
      ],
      "bbox_max": [
        1050.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9011393785476685,
        0.4335293471813202,
        -0.0
      ],
      "plane_d": -1405.2288818359375,
      "bbox_min": [
        902.8526611328125,
        1336.6116943359375,
        90.56400299072266
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": -533.9730834960938,
      "bbox_min": [
        1000.0,
        1382.3809814453125,
        96.19047546386719
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1382.3809814453125,
        96.19047546386719
      ],
      "bbox_max": [
        1000.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1404.0,
        91.30435180664062
      ],
      "bbox_max": [
        914.4931030273438,
        1509.5068359375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.901139497756958,
        -0.4335293769836426,
        0.0
      ],
      "plane_d": -169.67022705078125,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        94.50349426269531
      ],
      "bbox_max": [
        914.4931030273438,
        1509.5068359375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9898993968963623,
        -0.14177139103412628,
        0.0
      ],
      "plane_d": -678.9862060546875,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        94.50349426269531
      ],
      "bbox_max": [
        896.850830078125,
        1472.83544921875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -150.27244567871094,
      "bbox_min": [
        866.6666870117188,
        1404.0,
        91.33333587646484
      ],
      "bbox_max": [
        890.0,
        1440.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        83.47825622558594
      ],
      "bbox_max": [
        790.0,
        1540.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        83.47825622558594
      ],
      "bbox_max": [
        790.0,
        1530.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1320.0,
        83.91304779052734
      ],
      "bbox_max": [
        790.0,
        1530.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        93.04348754882812
      ],
      "bbox_max": [
        790.0,
        1530.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        730.0,
        1570.0,
        94.7826156616211
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        730.0,
        1620.0,
        96.95652770996094
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        730.0,
        1620.0,
        96.95652770996094
      ],
      "bbox_max": [
        980.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1620.0,
        103.91304016113281
      ],
      "bbox_max": [
        980.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1642.5,
        105.86956787109375
      ],
      "bbox_max": [
        980.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -979.9999389648438,
      "bbox_min": [
        980.0,
        1670.0,
        107.82609558105469
      ],
      "bbox_max": [
        980.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1642.5,
      "bbox_min": [
        962.5,
        1642.5,
        105.86956787109375
      ],
      "bbox_max": [
        967.5,
        1647.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1647.5,
      "bbox_min": [
        962.5,
        1642.5,
        106.08695983886719
      ],
      "bbox_max": [
        967.5,
        1647.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -967.5,
      "bbox_min": [
        967.5,
        1642.5,
        106.08695983886719
      ],
      "bbox_max": [
        967.5,
        1647.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        730.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        760.0,
        1570.0,
        94.7826156616211
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        780.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -979.9999389648438,
      "bbox_min": [
        940.0,
        1570.0,
        103.47825622558594
      ],
      "bbox_max": [
        980.0,
        1614.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1610.0,
        103.47825622558594
      ],
      "bbox_max": [
        940.0,
        1614.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        940.0,
        1610.0,
        103.65216827392578
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1612.5,
        103.65216827392578
      ],
      "bbox_max": [
        967.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1612.5,
      "bbox_min": [
        962.5,
        1612.5,
        104.56521606445312
      ],
      "bbox_max": [
        967.5,
        1617.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -967.5,
      "bbox_min": [
        962.5,
        1612.5,
        104.78260803222656
      ],
      "bbox_max": [
        967.5,
        1617.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1617.5,
      "bbox_min": [
        962.5,
        1617.5,
        104.7826156616211
      ],
      "bbox_max": [
        967.5,
        1617.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1570.0,
        94.7826156616211
      ],
      "bbox_max": [
        780.0,
        1620.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1300.0,
        1220.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        500.0,
        520.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        1170.0,
        118.00000762939453
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        500.0,
        520.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        118.00000762939453
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        500.0,
        520.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1629.9998779296875,
      "bbox_min": [
        1200.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1200.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1231.0,
        1101.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1630.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1630.0,
        1105.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        780.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        780.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        880.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        780.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        900.0,
        650.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        720.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        880.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1060.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1250.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1060.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1200.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1200.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1650.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        963.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1250.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        500.0,
        700.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        730.0,
        700.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        942.0,
        912.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        500.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        730.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        950.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1200.0,
        1070.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1070.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1096.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        858.3333740234375,
        1120.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        858.3333740234375,
        1120.0,
        98.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 527.358154296875,
      "bbox_min": [
        858.3333740234375,
        1120.0,
        98.0
      ],
      "bbox_max": [
        861.6666870117188,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1181.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1181.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        1125.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        500.0,
        700.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1010.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        1010.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        118.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1200.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1630.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1629.9998779296875,
      "bbox_min": [
        1630.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        1120.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        970.0,
        104.66666412353516
      ],
      "bbox_max": [
        1660.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1070.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1010.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1480.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        880.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        880.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1600.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        880.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1600.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        880.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1060.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1200.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        970.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        970.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1650.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        963.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        970.0,
        104.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1250.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1250.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        920.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1250.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        930.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1250.0,
        1111.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1250.0,
        1111.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1111.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1300.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 491.9349670410156,
      "bbox_min": [
        1300.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1336.0,
        1160.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": -800.432373046875,
      "bbox_min": [
        1593.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        500.0,
        700.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1170.0,
        118.00000762939453
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        730.0,
        700.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        500.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        118.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1070.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -332.7269287109375,
      "bbox_min": [
        950.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1096.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        950.0,
        970.0,
        103.00000762939453
      ],
      "bbox_max": [
        960.0,
        1090.0,
        108.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1080.0,
        103.00000762939453
      ],
      "bbox_max": [
        960.0,
        1090.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1096.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1010.0,
        970.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        845.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        845.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 527.358154296875,
      "bbox_min": [
        845.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        858.3333740234375,
        1130.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        500.0,
        520.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        1170.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        1105.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1200.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1105.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1629.9998779296875,
      "bbox_min": [
        1200.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1105.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1200.0,
        970.0,
        84.21052551269531
      ],
      "bbox_max": [
        1250.0,
        1101.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1200.0,
        970.0,
        84.21052551269531
      ],
      "bbox_max": [
        1250.0,
        1101.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        970.0,
        84.21052551269531
      ],
      "bbox_max": [
        1200.0,
        1070.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1105.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        780.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        970.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        780.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        880.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        780.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        900.0,
        650.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        880.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1060.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        970.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1875.2664794921875,
        920.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881490111351013,
        -0.9659269452095032,
        0.0
      ],
      "plane_d": 393.96661376953125,
      "bbox_min": [
        1804.7335205078125,
        900.8818359375,
        80.0
      ],
      "bbox_max": [
        1875.2664794921875,
        920.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071121335029602,
        -0.7071014642715454,
        -0.0
      ],
      "plane_d": 1926.682373046875,
      "bbox_min": [
        1804.7335205078125,
        906.79248046875,
        80.0
      ],
      "bbox_max": [
        1875.2664794921875,
        920.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": -675.4898071289062,
      "bbox_min": [
        1862.05908203125,
        906.79248046875,
        80.0
      ],
      "bbox_max": [
        1875.2664794921875,
        920.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        920.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1060.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        970.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1380.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        970.0,
        84.21052551269531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        0.2588212490081787,
        0.0
      ],
      "plane_d": 1490.1016845703125,
      "bbox_min": [
        1795.8818359375,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        967.05908203125,
        83.90095520019531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        0.2588212490081787,
        -0.0
      ],
      "plane_d": -2064.503662109375,
      "bbox_min": [
        1795.8818359375,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        967.05908203125,
        83.90095520019531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        -0.2588212490081787,
        -0.0
      ],
      "plane_d": 1979.2738037109375,
      "bbox_min": [
        1795.8818359375,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        945.0,
        81.57894897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        -0.2588212490081787,
        0.0
      ],
      "plane_d": -1575.3314208984375,
      "bbox_min": [
        1880.098876953125,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        945.0,
        81.57894897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1200.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        970.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1200.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        970.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        970.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        970.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        0.2588212490081787,
        -0.0
      ],
      "plane_d": -2064.503662109375,
      "bbox_min": [
        1795.8818359375,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        967.05908203125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        -0.2588212490081787,
        -0.0
      ],
      "plane_d": 1979.2738037109375,
      "bbox_min": [
        1795.8818359375,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        945.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        -0.2588212490081787,
        0.0
      ],
      "plane_d": -1575.3314208984375,
      "bbox_min": [
        1880.098876953125,
        930.0,
        80.0
      ],
      "bbox_max": [
        1884.1181640625,
        945.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        930.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071121335029602,
        -0.7071014642715454,
        -0.0
      ],
      "plane_d": 1926.682373046875,
      "bbox_min": [
        1801.7926025390625,
        920.0,
        80.0
      ],
      "bbox_max": [
        1878.2073974609375,
        922.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": -675.4898071289062,
      "bbox_min": [
        1875.2664794921875,
        920.0,
        80.0
      ],
      "bbox_max": [
        1878.2073974609375,
        922.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        920.0,
        95.0
      ],
      "bbox_max": [
        1770.0,
        930.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        500.0,
        700.0,
        80.0
      ],
      "bbox_max": [
        1231.0,
        1170.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        500.0,
        700.0,
        80.0
      ],
      "bbox_max": [
        1183.0,
        1170.0,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        730.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        730.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        500.0,
        700.0,
        80.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        861.6666870117188,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1183.0,
        1170.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        861.6666870117188,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        861.6666870117188,
        1120.0,
        80.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 527.358154296875,
      "bbox_min": [
        861.6666870117188,
        1120.0,
        80.0
      ],
      "bbox_max": [
        891.6666870117188,
        1130.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1150.0,
        1070.0,
        94.73684692382812
      ],
      "bbox_max": [
        1231.0,
        1153.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1150.0,
        1120.0,
        94.73684692382812
      ],
      "bbox_max": [
        1183.0,
        1153.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1150.0,
        1120.0,
        94.73684692382812
      ],
      "bbox_max": [
        1183.0,
        1131.3636474609375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1150.0,
        1120.0,
        94.73684692382812
      ],
      "bbox_max": [
        1183.0,
        1131.3636474609375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1070.0,
        94.73684692382812
      ],
      "bbox_max": [
        1200.0,
        1101.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        500.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        78.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        500.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        500.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        78.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        500.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        500.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        970.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        650.0,
        520.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        600.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        500.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        970.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        500.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        500.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1170.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        500.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -295.1610107421875,
      "bbox_min": [
        504.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        730.0,
        600.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736146807670593,
        0.7390826344490051,
        -0.0
      ],
      "plane_d": -1605.140380859375,
      "bbox_min": [
        916.3604125976562,
        1310.0,
        73.63604736328125
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736147403717041,
        -0.7390826940536499,
        0.0
      ],
      "plane_d": 501.24530029296875,
      "bbox_min": [
        916.3604125976562,
        1513.3883056640625,
        73.63604736328125
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        855.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        72.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 328.7020263671875,
      "bbox_min": [
        855.0,
        1160.0,
        60.0
      ],
      "bbox_max": [
        873.75,
        1170.0,
        69.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        780.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1690.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        78.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1170.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        942.0,
        970.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        941.9998779296875,
        970.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 328.7020263671875,
      "bbox_min": [
        873.75,
        1160.0,
        69.375
      ],
      "bbox_max": [
        891.0,
        1170.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1690.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1570.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6736146807670593,
        0.7390826344490051,
        -0.0
      ],
      "plane_d": -1605.140380859375,
      "bbox_min": [
        893.5803833007812,
        1310.0,
        71.35804748535156
      ],
      "bbox_max": [
        945.5584716796875,
        1400.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        64.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.901139497756958,
        -0.4335293769836426,
        0.0
      ],
      "plane_d": -169.67022705078125,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        71.35804748535156
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736147403717041,
        -0.7390826940536499,
        0.0
      ],
      "plane_d": 501.24530029296875,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        71.35804748535156
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9898993968963623,
        -0.14177139103412628,
        0.0
      ],
      "plane_d": -678.9862060546875,
      "bbox_min": [
        893.5803833007812,
        1450.0,
        71.35804748535156
      ],
      "bbox_max": [
        896.850830078125,
        1472.83544921875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1310.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        730.0,
        600.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": 11.940444946289062,
      "bbox_min": [
        780.0,
        650.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        780.0,
        650.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        780.0,
        650.0,
        60.0
      ],
      "bbox_max": [
        900.0,
        650.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        689.9500122070312,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        930.0,
        1830.0,
        60.0
      ],
      "bbox_max": [
        1817.94091796875,
        2850.0,
        317.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1200.0,
        1830.0,
        60.0
      ],
      "bbox_max": [
        1817.94091796875,
        2850.0,
        317.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2550.0,
      "bbox_min": [
        1200.0,
        2395.0,
        60.0
      ],
      "bbox_max": [
        1817.94091796875,
        2850.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": -416.31573486328125,
      "bbox_min": [
        1200.0,
        2395.0,
        80.0
      ],
      "bbox_max": [
        1817.94091796875,
        2550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        2395.0,
        80.0
      ],
      "bbox_max": [
        1817.94091796875,
        2550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        -0.7071041464805603,
        -0.0
      ],
      "plane_d": 3079.259765625,
      "bbox_min": [
        1804.7335205078125,
        2536.79248046875,
        80.0
      ],
      "bbox_max": [
        1817.94091796875,
        2550.0,
        81.760986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1230.0,
        2399.999755859375,
        80.0
      ],
      "bbox_max": [
        1817.94091796875,
        2550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        -0.7071041464805603,
        -0.0
      ],
      "plane_d": 3079.259765625,
      "bbox_min": [
        1804.7335205078125,
        2536.79248046875,
        80.0
      ],
      "bbox_max": [
        1817.94091796875,
        2550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1230.0,
        2540.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        2550.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        1200.0,
        2550.0,
        60.0
      ],
      "bbox_max": [
        1804.7335205078125,
        2850.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1200.0,
        2550.0,
        60.0
      ],
      "bbox_max": [
        1804.7335205078125,
        2830.0,
        100.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": -338.31268310546875,
      "bbox_min": [
        1200.0,
        2600.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        2820.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.6234195072684088e-06,
        0.09974129498004913,
        0.995013415813446
      ],
      "plane_d": -338.9309387207031,
      "bbox_min": [
        1250.0,
        2600.0,
        60.0
      ],
      "bbox_max": [
        1740.0,
        2800.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -995.3514404296875,
      "bbox_min": [
        1250.0,
        2600.0,
        60.0
      ],
      "bbox_max": [
        1740.0,
        2800.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        2620.0,
        67.07054138183594
      ],
      "bbox_max": [
        1270.0,
        2729.029052734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 2935.16650390625,
      "bbox_min": [
        1267.123046875,
        2620.0,
        60.0
      ],
      "bbox_max": [
        1430.0,
        2800.0,
        78.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1269.58935546875,
        2652.5,
        60.0
      ],
      "bbox_max": [
        1390.0,
        2800.0,
        74.7500228881836
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1390.0,
        2652.5,
        74.74208068847656
      ],
      "bbox_max": [
        1390.0,
        2652.579345703125,
        74.7500228881836
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09839963912963867,
        0.09839963912963867,
        0.99027019739151
      ],
      "plane_d": -459.9027099609375,
      "bbox_min": [
        1269.58935546875,
        2750.0,
        60.0
      ],
      "bbox_max": [
        1270.0,
        2800.0,
        64.96832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06931208819150925,
        0.09031800925731659,
        0.9934980273246765
      ],
      "plane_d": -400.94677734375,
      "bbox_min": [
        1269.58935546875,
        2750.0,
        64.8908462524414
      ],
      "bbox_max": [
        1270.0,
        2751.091552734375,
        64.96832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06931208819150925,
        0.09031800925731659,
        0.9934980273246765
      ],
      "plane_d": -400.94677734375,
      "bbox_min": [
        1267.123046875,
        2731.110107421875,
        64.96662139892578
      ],
      "bbox_max": [
        1270.0,
        2750.333740234375,
        66.86129760742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1250.0,
        2600.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        2820.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06931208819150925,
        0.09031800925731659,
        0.9934980273246765
      ],
      "plane_d": -400.94677734375,
      "bbox_min": [
        1250.0,
        2600.0,
        60.0
      ],
      "bbox_max": [
        1740.0,
        2820.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09839963912963867,
        0.09839963912963867,
        0.99027019739151
      ],
      "plane_d": -459.9027099609375,
      "bbox_min": [
        1250.0,
        2751.091552734375,
        60.0
      ],
      "bbox_max": [
        1270.0,
        2820.0,
        64.8908462524414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        2753.487060546875,
        60.0
      ],
      "bbox_max": [
        1270.0,
        2800.0,
        64.65131378173828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -2912.705078125,
      "bbox_min": [
        1270.0,
        2600.0,
        60.422855377197266
      ],
      "bbox_max": [
        1740.0,
        2800.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        2620.0,
        67.09709930419922
      ],
      "bbox_max": [
        1270.0,
        2729.029052734375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -995.3514404296875,
      "bbox_min": [
        1270.0,
        2600.0,
        60.422855377197266
      ],
      "bbox_max": [
        1740.0,
        2800.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1608.056884765625,
        2620.0,
        77.99995422363281
      ],
      "bbox_max": [
        1740.0,
        2620.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 2935.16650390625,
      "bbox_min": [
        1270.0,
        2600.0,
        60.422855377197266
      ],
      "bbox_max": [
        1580.0,
        2800.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.049937617033720016,
        0.9987523555755615
      ],
      "plane_d": -209.73800659179688,
      "bbox_min": [
        1270.0,
        2600.0,
        60.422855377197266
      ],
      "bbox_max": [
        1580.0,
        2800.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        2600.0,
        60.422855377197266
      ],
      "bbox_max": [
        1580.0,
        2800.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1370.0,
        2600.0,
        74.74208068847656
      ],
      "bbox_max": [
        1580.0,
        2690.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        1370.0,
        2668.75,
        74.74209594726562
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        76.56251525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2690.0,
      "bbox_min": [
        1370.0,
        2690.0,
        74.74209594726562
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        75.50003051757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1430.0,
        2600.0,
        78.0
      ],
      "bbox_max": [
        1580.0,
        2640.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1460.0,
        2620.0,
        78.0
      ],
      "bbox_max": [
        1550.0,
        2640.0,
        79.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1460.0,
        2620.0,
        78.0
      ],
      "bbox_max": [
        1460.0,
        2640.0,
        79.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1460.0,
        2600.0,
        78.0
      ],
      "bbox_max": [
        1460.0,
        2620.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        2600.0,
        70.00000762939453
      ],
      "bbox_max": [
        1580.0,
        2800.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1370.0,
        2600.0,
        75.50003051757812
      ],
      "bbox_max": [
        1580.0,
        2690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1550.0,
        2620.0,
        78.0
      ],
      "bbox_max": [
        1580.0,
        2640.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1550.0,
        2620.0,
        78.0
      ],
      "bbox_max": [
        1550.0,
        2640.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1430.0,
        2620.0,
        78.0
      ],
      "bbox_max": [
        1460.0,
        2640.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1460.0,
        2620.0,
        78.0
      ],
      "bbox_max": [
        1460.0,
        2640.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2690.0,
      "bbox_min": [
        1370.0,
        2690.0,
        75.50003051757812
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1218.0,
        2550.0,
        80.0
      ],
      "bbox_max": [
        1804.7335205078125,
        2830.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        0.2588212490081787,
        0.0
      ],
      "plane_d": 1068.2230224609375,
      "bbox_min": [
        1795.8818359375,
        2550.0,
        80.0
      ],
      "bbox_max": [
        1804.7335205078125,
        2597.05908203125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        -0.7071041464805603,
        -0.0
      ],
      "plane_d": 3079.259765625,
      "bbox_min": [
        1801.7926025390625,
        2550.0,
        80.0
      ],
      "bbox_max": [
        1804.7335205078125,
        2552.94091796875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1218.0,
        2550.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        2830.0,
        100.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 2935.16650390625,
      "bbox_min": [
        1218.0,
        2580.0,
        98.0
      ],
      "bbox_max": [
        1646.0,
        2800.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1370.0,
        2640.0,
        98.0
      ],
      "bbox_max": [
        1620.0,
        2690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1604.6153564453125,
        2640.0,
        98.0
      ],
      "bbox_max": [
        1620.0,
        2690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        0.7761140465736389,
        0.0
      ],
      "plane_d": -1037.08251953125,
      "bbox_min": [
        1604.6153564453125,
        2640.0,
        98.0
      ],
      "bbox_max": [
        1620.0,
        2652.5,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        1370.0,
        2668.75,
        98.0
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2690.0,
      "bbox_min": [
        1370.0,
        2690.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 981.4642333984375,
      "bbox_min": [
        1430.0,
        2590.0,
        98.0
      ],
      "bbox_max": [
        1646.0,
        2640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        0.7761140465736389,
        0.0
      ],
      "plane_d": -1037.08251953125,
      "bbox_min": [
        1486.0,
        2590.0,
        98.0
      ],
      "bbox_max": [
        1646.0,
        2640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39872613549232483,
        0.0,
        -0.9170700907707214
      ],
      "plane_d": 746.1760864257812,
      "bbox_min": [
        1641.4000244140625,
        2590.0,
        98.0
      ],
      "bbox_max": [
        1646.0,
        2600.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1486.0,
        2600.0,
        98.0
      ],
      "bbox_max": [
        1580.0,
        2640.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1550.0,
        2620.0,
        98.0
      ],
      "bbox_max": [
        1550.0,
        2640.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2600.0,
      "bbox_min": [
        1486.0,
        2600.0,
        98.0
      ],
      "bbox_max": [
        1524.0,
        2600.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1430.0,
        2620.0,
        98.0
      ],
      "bbox_max": [
        1460.0,
        2640.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1460.0,
        2620.0,
        98.0
      ],
      "bbox_max": [
        1460.0,
        2640.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.16439899802207947,
        0.0,
        -0.9863939881324768
      ],
      "plane_d": 298.87738037109375,
      "bbox_min": [
        1218.0,
        2580.0,
        98.0
      ],
      "bbox_max": [
        1334.0,
        2660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -507.1402587890625,
      "bbox_min": [
        1330.0,
        2580.0,
        98.0
      ],
      "bbox_max": [
        1334.0,
        2590.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -2912.705078125,
      "bbox_min": [
        1270.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1740.0,
        2800.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1270.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1450.349853515625,
        2729.029052734375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        2620.0,
        80.0
      ],
      "bbox_max": [
        1270.0,
        2729.029052734375,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 682.447998046875,
      "bbox_min": [
        1330.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1450.349853515625,
        2600.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.0,
        -0.9363292455673218
      ],
      "plane_d": -430.71142578125,
      "bbox_min": [
        1440.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1450.349853515625,
        2588.55224609375,
        83.88118743896484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": -995.3514404296875,
      "bbox_min": [
        1270.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1740.0,
        2800.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1559.650390625,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1740.0,
        2620.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": -547.80126953125,
      "bbox_min": [
        1559.650390625,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1720.0,
        2590.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 656.2473754882812,
      "bbox_min": [
        1559.650390625,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1567.0,
        2586.0732421875,
        82.93986511230469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 2935.16650390625,
      "bbox_min": [
        1270.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1620.0,
        2800.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        0.7761140465736389,
        0.0
      ],
      "plane_d": -1037.08251953125,
      "bbox_min": [
        1270.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1620.0,
        2800.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 656.2473754882812,
      "bbox_min": [
        1530.7691650390625,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1567.0,
        2590.0,
        94.49234008789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1620.0,
        2800.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1370.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1620.0,
        2690.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1430.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1620.0,
        2690.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1430.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1580.0,
        2640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1482.0,
      "bbox_min": [
        1480.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1580.0,
        2640.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -2640.0,
      "bbox_min": [
        1480.0,
        2600.0,
        80.0
      ],
      "bbox_max": [
        1482.0,
        2640.0,
        94.00016021728516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2600.0,
      "bbox_min": [
        1480.0,
        2600.0,
        80.0
      ],
      "bbox_max": [
        1482.0,
        2600.0,
        94.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1528.0,
      "bbox_min": [
        1482.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1580.0,
        2640.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1528.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1580.0,
        2640.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2640.0,
      "bbox_min": [
        1528.0,
        2620.0,
        80.0
      ],
      "bbox_max": [
        1550.0,
        2640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1550.0,
        2620.0,
        80.0
      ],
      "bbox_max": [
        1550.0,
        2640.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 656.2473754882812,
      "bbox_min": [
        1528.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1543.07666015625,
        2600.0,
        95.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2600.0,
      "bbox_min": [
        1528.0,
        2600.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        2600.0,
        94.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7241400480270386,
        0.0,
        -0.6896529793739319
      ],
      "plane_d": 1169.244384765625,
      "bbox_min": [
        1482.0,
        2580.0,
        91.0
      ],
      "bbox_max": [
        1528.0,
        2610.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 656.2473754882812,
      "bbox_min": [
        1521.3333740234375,
        2580.0,
        91.0
      ],
      "bbox_max": [
        1528.0,
        2600.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2600.0,
      "bbox_min": [
        1522.0,
        2600.0,
        96.66666412353516
      ],
      "bbox_max": [
        1525.3333740234375,
        2600.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2600.0,
      "bbox_min": [
        1521.3333740234375,
        2600.0,
        91.0
      ],
      "bbox_max": [
        1528.0,
        2600.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2600.0,
      "bbox_min": [
        1482.0,
        2580.0,
        91.0
      ],
      "bbox_max": [
        1488.6666259765625,
        2600.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.0,
        -0.9363292455673218
      ],
      "plane_d": -430.71142578125,
      "bbox_min": [
        1484.7999267578125,
        2580.0,
        96.79998779296875
      ],
      "bbox_max": [
        1488.0,
        2590.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.0,
        -0.9363292455673218
      ],
      "plane_d": -430.71142578125,
      "bbox_min": [
        1480.0,
        2580.0,
        92.00003051757812
      ],
      "bbox_max": [
        1484.7999267578125,
        2640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -2640.0,
      "bbox_min": [
        1480.0,
        2640.0,
        95.00001525878906
      ],
      "bbox_max": [
        1482.0,
        2640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1430.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        2640.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1460.0,
        2620.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        2640.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -2640.0,
      "bbox_min": [
        1460.0,
        2640.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        2640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.0,
        -0.9363292455673218
      ],
      "plane_d": -430.71142578125,
      "bbox_min": [
        1466.9234619140625,
        2580.0,
        90.0962905883789
      ],
      "bbox_max": [
        1480.0,
        2590.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        1370.0,
        2668.75,
        80.0
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2690.0,
      "bbox_min": [
        1370.0,
        2690.0,
        80.0
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3511234521865845,
        0.0,
        -0.9363292455673218
      ],
      "plane_d": -430.71142578125,
      "bbox_min": [
        1440.0,
        2580.0,
        80.0
      ],
      "bbox_max": [
        1479.231201171875,
        2590.0,
        94.71170043945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        1200.0,
        1830.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        2800.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2550.0,
      "bbox_min": [
        1200.0,
        2400.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        2800.0,
        317.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        2400.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2550.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1645.0,
        2400.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1645.0,
        2450.0,
        118.0
      ],
      "bbox_max": [
        1665.0,
        2550.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1200.0,
        2550.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        2800.0,
        317.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 2935.16650390625,
      "bbox_min": [
        1200.0,
        2550.0,
        100.0
      ],
      "bbox_max": [
        1665.0,
        2800.0,
        317.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1270.0,
        2640.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        2800.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1370.0,
        2640.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        2690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        1370.0,
        2640.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        2690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        0.7761140465736389,
        0.0
      ],
      "plane_d": -1037.08251953125,
      "bbox_min": [
        1370.0,
        2640.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        2690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1370.0,
        2652.5,
        100.0
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2690.0,
      "bbox_min": [
        1370.0,
        2690.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        2690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        0.7761140465736389,
        0.0
      ],
      "plane_d": -1037.08251953125,
      "bbox_min": [
        1430.0,
        2550.0,
        100.0
      ],
      "bbox_max": [
        1665.0,
        2640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1645.0,
        2550.0,
        118.0
      ],
      "bbox_max": [
        1665.0,
        2569.099853515625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2620.0,
      "bbox_min": [
        1430.0,
        2609.931396484375,
        100.0
      ],
      "bbox_max": [
        1580.0,
        2640.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1460.0,
        2620.0,
        100.0
      ],
      "bbox_max": [
        1550.0,
        2640.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        1460.0,
        2620.0,
        100.0
      ],
      "bbox_max": [
        1539.5921630859375,
        2640.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6643693447113037,
        -0.7474044561386108,
        0.0
      ],
      "plane_d": 937.4325561523438,
      "bbox_min": [
        1470.4078369140625,
        2620.0,
        100.0
      ],
      "bbox_max": [
        1539.5921630859375,
        2622.79736328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6643693447113037,
        -0.7474044561386108,
        -0.0
      ],
      "plane_d": 2937.184326171875,
      "bbox_min": [
        1470.4078369140625,
        2620.0,
        100.0
      ],
      "bbox_max": [
        1473.5548095703125,
        2622.79736328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6643693447113037,
        -0.7474044561386108,
        0.0
      ],
      "plane_d": 937.4325561523438,
      "bbox_min": [
        1473.5548095703125,
        2609.931396484375,
        100.0
      ],
      "bbox_max": [
        1536.4451904296875,
        2620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6643693447113037,
        -0.7474044561386108,
        -0.0
      ],
      "plane_d": 2937.184326171875,
      "bbox_min": [
        1473.5548095703125,
        2609.931396484375,
        100.0
      ],
      "bbox_max": [
        1484.8818359375,
        2620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -507.1402587890625,
      "bbox_min": [
        1200.0,
        2580.0,
        100.0
      ],
      "bbox_max": [
        1370.0,
        2660.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16439899802207947,
        0.0,
        -0.9863939881324768
      ],
      "plane_d": 298.87738037109375,
      "bbox_min": [
        1200.0,
        2640.0,
        100.0
      ],
      "bbox_max": [
        1218.0,
        2660.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1900.0,
      "bbox_min": [
        1200.0,
        1830.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1529.998779296875,
      "bbox_min": [
        1200.0,
        1830.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1900.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1200.0,
        1830.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1900.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1200.0,
        1830.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1900.0,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1210.0,
        1830.0,
        118.0
      ],
      "bbox_max": [
        1230.0,
        1900.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08662962168455124,
        0.0,
        0.9962406754493713
      ],
      "plane_d": 8.662956237792969,
      "bbox_min": [
        1200.0,
        1900.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        210.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2350.0,
      "bbox_min": [
        1249.9793701171875,
        1900.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        137.3913116455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1529.998779296875,
      "bbox_min": [
        1249.9793701171875,
        1900.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        2350.0,
        124.34783172607422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2580.93994140625,
      "bbox_min": [
        1300.0,
        2334.116943359375,
        100.0
      ],
      "bbox_max": [
        1315.883056640625,
        2350.0,
        105.72896575927734
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1500.0,
      "bbox_min": [
        1390.5555419921875,
        2350.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        137.3913116455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        2395.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        137.3913116455078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 722.25,
      "bbox_min": [
        1390.5555419921875,
        2360.0,
        100.0
      ],
      "bbox_max": [
        1415.0,
        2370.0,
        112.22222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        1200.0,
        1900.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -4.882812731921149e-07,
        0.0
      ],
      "plane_d": 1250.0009765625,
      "bbox_min": [
        1200.0,
        1950.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        210.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2350.0,
      "bbox_min": [
        1249.9998779296875,
        1950.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        210.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1529.998779296875,
      "bbox_min": [
        1249.9998779296875,
        1950.0,
        100.0
      ],
      "bbox_max": [
        1530.0001220703125,
        2350.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084976196289,
        0.7071050405502319,
        0.0
      ],
      "plane_d": -719.9937133789062,
      "bbox_min": [
        1249.9998779296875,
        2284.09619140625,
        100.00178527832031
      ],
      "bbox_max": [
        1400.0,
        2350.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1360.050537109375,
        2299.619384765625,
        125.0
      ],
      "bbox_max": [
        1400.0,
        2350.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999995231628418,
        0.0009812990901991725,
        -0.0
      ],
      "plane_d": -1362.35595703125,
      "bbox_min": [
        1360.050537109375,
        2299.619384765625,
        125.0
      ],
      "bbox_max": [
        1360.0999755859375,
        2350.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1249.9998779296875,
        2284.09619140625,
        100.00178527832031
      ],
      "bbox_max": [
        1315.883056640625,
        2350.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071108222007751,
        0.7071027159690857,
        0.0
      ],
      "plane_d": -742.4475708007812,
      "bbox_min": [
        1249.9998779296875,
        2300.0,
        135.0
      ],
      "bbox_max": [
        1300.0,
        2350.0,
        142.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3080947995185852,
        0.3080947995185852,
        -0.9000862240791321
      ],
      "plane_d": -978.899658203125,
      "bbox_min": [
        1249.9998779296875,
        2316.964599609375,
        135.0
      ],
      "bbox_max": [
        1261.9649658203125,
        2331.378173828125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071095108985901,
        0.7071040868759155,
        0.0
      ],
      "plane_d": -2510.197265625,
      "bbox_min": [
        1249.9998779296875,
        2284.09619140625,
        100.00178527832031
      ],
      "bbox_max": [
        1315.883056640625,
        2350.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3071087598800659,
        0.3071087598800659,
        -0.9007599949836731
      ],
      "plane_d": -977.6284790039062,
      "bbox_min": [
        1249.9998779296875,
        2284.09619140625,
        104.34782409667969
      ],
      "bbox_max": [
        1315.883056640625,
        2350.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071008682250977,
        0.7071126699447632,
        0.0
      ],
      "plane_d": -742.483154296875,
      "bbox_min": [
        1249.9998779296875,
        2300.0,
        125.01398468017578
      ],
      "bbox_max": [
        1264.6446533203125,
        2321.664794921875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3080947995185852,
        0.3080947995185852,
        -0.9000862240791321
      ],
      "plane_d": -978.899658203125,
      "bbox_min": [
        1249.9998779296875,
        2312.2138671875,
        131.76498413085938
      ],
      "bbox_max": [
        1254.7001953125,
        2321.664794921875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162274956703186,
        -0.3162274956703186,
        -0.8944273591041565
      ],
      "plane_d": 1266.03369140625,
      "bbox_min": [
        1285.8577880859375,
        2319.974609375,
        104.34782409667969
      ],
      "bbox_max": [
        1315.883056640625,
        2350.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        0.7071098685264587,
        0.0
      ],
      "plane_d": -742.4733276367188,
      "bbox_min": [
        1285.8577880859375,
        2335.85791015625,
        125.0
      ],
      "bbox_max": [
        1300.0,
        2350.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2580.93994140625,
      "bbox_min": [
        1300.0,
        2334.116943359375,
        104.34782409667969
      ],
      "bbox_max": [
        1315.883056640625,
        2350.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1315.4000244140625,
      "bbox_min": [
        1249.9998779296875,
        2160.0,
        100.0
      ],
      "bbox_max": [
        1315.4000244140625,
        2240.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2200.0,
      "bbox_min": [
        1249.9998779296875,
        2160.0,
        100.0
      ],
      "bbox_max": [
        1315.4000244140625,
        2200.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2180.0,
      "bbox_min": [
        1249.9998779296875,
        2160.0,
        120.0
      ],
      "bbox_max": [
        1290.0,
        2180.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2160.0,
      "bbox_min": [
        1249.9998779296875,
        2160.0,
        120.0
      ],
      "bbox_max": [
        1290.0,
        2160.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1250.0,
        2350.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        158.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1500.0,
      "bbox_min": [
        1289.5999755859375,
        2350.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        2395.0,
        137.3913116455078
      ],
      "bbox_max": [
        1680.0,
        2400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4138029217720032,
        0.0,
        0.9103664755821228
      ],
      "plane_d": 426.2170104980469,
      "bbox_min": [
        1289.5999755859375,
        2380.0,
        118.0
      ],
      "bbox_max": [
        1294.0,
        2390.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4138029217720032,
        0.0,
        0.9103664755821228
      ],
      "plane_d": 426.2170104980469,
      "bbox_min": [
        1250.0,
        2360.0,
        100.0
      ],
      "bbox_max": [
        1390.5555419921875,
        2390.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 722.25,
      "bbox_min": [
        1379.0,
        2360.0,
        112.22222900390625
      ],
      "bbox_max": [
        1390.5555419921875,
        2370.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1200.0,
        1950.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        2326.431640625,
        185.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0003416258841753006,
        -0.0
      ],
      "plane_d": 1250.7650146484375,
      "bbox_min": [
        1222.928955078125,
        1950.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        2326.431640625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071008682250977,
        0.7071126699447632,
        0.0
      ],
      "plane_d": -742.483154296875,
      "bbox_min": [
        1249.9703369140625,
        2299.958984375,
        118.0
      ],
      "bbox_max": [
        1249.9998779296875,
        2326.431640625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071095108985901,
        0.7071040868759155,
        0.0
      ],
      "plane_d": -2510.197265625,
      "bbox_min": [
        1249.9793701171875,
        2299.958984375,
        118.0
      ],
      "bbox_max": [
        1249.9998779296875,
        2300.0,
        125.01398468017578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3071087598800659,
        0.3071087598800659,
        -0.9007599949836731
      ],
      "plane_d": -977.6284790039062,
      "bbox_min": [
        1249.9793701171875,
        2299.958984375,
        125.0
      ],
      "bbox_max": [
        1249.9998779296875,
        2300.0,
        125.01398468017578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3080947995185852,
        0.3080947995185852,
        -0.9000862240791321
      ],
      "plane_d": -978.899658203125,
      "bbox_min": [
        1249.9703369140625,
        2312.18896484375,
        131.74801635742188
      ],
      "bbox_max": [
        1249.9998779296875,
        2326.431640625,
        136.63165283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4138029217720032,
        -0.9103664755821228
      ],
      "plane_d": 943.3051147460938,
      "bbox_min": [
        1222.928955078125,
        1950.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        2326.40185546875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3080947995185852,
        0.3080947995185852,
        -0.9000862240791321
      ],
      "plane_d": -978.899658203125,
      "bbox_min": [
        1222.928955078125,
        2292.0,
        118.0
      ],
      "bbox_max": [
        1249.9752197265625,
        2326.40185546875,
        136.611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1230.0,
        1950.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1976.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0003416258841753006,
        -0.0
      ],
      "plane_d": 1250.7650146484375,
      "bbox_min": [
        1249.9793701171875,
        2239.949462890625,
        100.0
      ],
      "bbox_max": [
        1249.9998779296875,
        2299.9794921875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071095108985901,
        0.7071040868759155,
        0.0
      ],
      "plane_d": -2510.197265625,
      "bbox_min": [
        1249.9793701171875,
        2299.958984375,
        100.0
      ],
      "bbox_max": [
        1249.9998779296875,
        2299.9794921875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1529.998779296875,
      "bbox_min": [
        1200.0,
        1900.0,
        113.73999786376953
      ],
      "bbox_max": [
        1530.0,
        1950.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1200.0,
        1900.0,
        113.73999786376953
      ],
      "bbox_max": [
        1429.5,
        1950.0,
        156.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3749796748161316,
        -0.0,
        -0.9270330667495728
      ],
      "plane_d": 605.8421630859375,
      "bbox_min": [
        1210.0,
        1900.0,
        138.0
      ],
      "bbox_max": [
        1274.5,
        1910.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 156.0,
      "bbox_min": [
        1210.0,
        1900.0,
        156.0
      ],
      "bbox_max": [
        1230.0,
        1910.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44736114144325256,
        0.0,
        -0.8943533897399902
      ],
      "plane_d": 731.6082763671875,
      "bbox_min": [
        1200.0,
        1900.0,
        113.73999786376953
      ],
      "bbox_max": [
        1408.0,
        1950.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4099385142326355,
        0.0,
        -0.9121131896972656
      ],
      "plane_d": -396.5950012207031,
      "bbox_min": [
        1200.0,
        1900.0,
        118.0
      ],
      "bbox_max": [
        1274.5,
        1950.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1200.0,
        1900.0,
        118.0
      ],
      "bbox_max": [
        1230.0,
        1950.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        930.0,
        1830.0,
        79.9999771118164
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        930.0,
        1830.0,
        79.9999771118164
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2185.0,
      "bbox_min": [
        930.0,
        2185.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        2185.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        980.0,
        1830.0,
        79.9999771118164
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        1070.0,
        1900.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        160.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1900.0,
      "bbox_min": [
        1070.0,
        1900.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1070.0,
        1900.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        1070.0,
        1950.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        97.64705657958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277936935425,
        -0.0,
        0.9486833810806274
      ],
      "plane_d": -449.04345703125,
      "bbox_min": [
        1140.8695068359375,
        2280.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2300.0,
        97.64705657958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -2279.999755859375,
      "bbox_min": [
        1140.8695068359375,
        2280.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2280.0,
        97.64705657958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2140.0,
      "bbox_min": [
        1120.0,
        2140.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2200.0,
        97.64704895019531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1120.0,
        2140.0,
        80.0
      ],
      "bbox_max": [
        1120.0,
        2200.0,
        90.58824157714844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1579904556274414,
        0.0,
        0.9874407052993774
      ],
      "plane_d": 90.84447479248047,
      "bbox_min": [
        1070.0,
        2331.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        97.64705657958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2331.0,
      "bbox_min": [
        1074.9998779296875,
        2331.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2357.0,
        96.80001068115234
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2357.0,
      "bbox_min": [
        1171.0,
        2357.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2357.0,
        96.80001068115234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        1070.0,
        2331.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        97.64705657958984
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -2350.0,
      "bbox_min": [
        1070.0,
        2331.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        97.64705657958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2331.0,
      "bbox_min": [
        1070.0,
        2331.0,
        80.0
      ],
      "bbox_max": [
        1180.0,
        2331.0,
        97.64705657958984
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1119.9998779296875,
      "bbox_min": [
        1120.0,
        2350.0,
        87.20000457763672
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        97.64705657958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2357.0,
      "bbox_min": [
        1171.0,
        2357.0,
        95.36000061035156
      ],
      "bbox_max": [
        1180.0,
        2357.0,
        97.64705657958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -2260.0,
      "bbox_min": [
        1070.0,
        1910.0,
        84.70587921142578
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        1070.0,
        1910.0,
        84.70587921142578
      ],
      "bbox_max": [
        1180.0,
        2200.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2140.0,
      "bbox_min": [
        1120.0,
        2140.0,
        90.58824157714844
      ],
      "bbox_max": [
        1180.0,
        2200.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2200.0,
      "bbox_min": [
        1120.0,
        2200.0,
        90.58824157714844
      ],
      "bbox_max": [
        1180.0,
        2200.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1070.0,
        1910.0,
        98.0
      ],
      "bbox_max": [
        1180.0,
        1950.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40613850951194763,
        0.0,
        -0.9138116240501404
      ],
      "plane_d": -347.0453796386719,
      "bbox_min": [
        1070.0,
        1930.0,
        98.0
      ],
      "bbox_max": [
        1120.0,
        1950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1070.0,
        1930.0,
        98.0
      ],
      "bbox_max": [
        1075.0,
        1950.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2331.0,
      "bbox_min": [
        1070.0,
        2260.0,
        84.70587921142578
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1120.0,
        2331.0,
        107.50242614746094
      ],
      "bbox_max": [
        1120.0,
        2350.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.178386390209198,
        0.0,
        -0.9839605689048767
      ],
      "plane_d": -94.13188171386719,
      "bbox_min": [
        1120.0,
        2331.0,
        90.5882339477539
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        118.74529266357422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2350.0,
      "bbox_min": [
        1120.0,
        2331.0,
        107.38323974609375
      ],
      "bbox_max": [
        1180.0,
        2350.0,
        118.74529266357422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1120.0,
        2331.0,
        107.38323974609375
      ],
      "bbox_max": [
        1120.0,
        2350.0,
        107.73252868652344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13319019973278046,
        -0.5378717184066772,
        -0.8324388861656189
      ],
      "plane_d": 1226.7943115234375,
      "bbox_min": [
        1120.0,
        2331.0,
        90.5882339477539
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        118.26090240478516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15940022468566895,
        -0.44263002276420593,
        -0.8824228644371033
      ],
      "plane_d": 974.1495361328125,
      "bbox_min": [
        1120.0,
        2331.0,
        90.5882339477539
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        118.26090240478516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        1120.0,
        2331.0,
        90.5882339477539
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        118.26090240478516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -2350.0,
      "bbox_min": [
        1120.0,
        2350.0,
        90.5882339477539
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        1120.0,
        2350.0,
        90.5882339477539
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        105.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1416778862476349,
        0.44285228848457336,
        -0.885330080986023
      ],
      "plane_d": -1108.90283203125,
      "bbox_min": [
        1120.0,
        2350.0,
        96.58822631835938
      ],
      "bbox_max": [
        1180.0,
        2357.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2357.0,
      "bbox_min": [
        1171.0,
        2357.0,
        96.58822631835938
      ],
      "bbox_max": [
        1180.0,
        2357.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.149153932929039,
        0.5366066098213196,
        -0.8305457830429077
      ],
      "plane_d": -1344.172119140625,
      "bbox_min": [
        1120.0,
        2331.0,
        105.0
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        118.26090240478516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2350.0,
      "bbox_min": [
        1120.0,
        2331.0,
        105.0
      ],
      "bbox_max": [
        1180.0,
        2359.84130859375,
        118.26090240478516
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1416778862476349,
        0.44285228848457336,
        -0.885330080986023
      ],
      "plane_d": -1108.90283203125,
      "bbox_min": [
        1120.0,
        2350.0,
        105.0
      ],
      "bbox_max": [
        1180.0,
        2359.84130859375,
        111.80000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1119.9998779296875,
      "bbox_min": [
        1120.0,
        2355.31787109375,
        105.0
      ],
      "bbox_max": [
        1120.0,
        2359.84130859375,
        107.38323974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1119.9998779296875,
      "bbox_min": [
        1120.0,
        2355.60107421875,
        105.0
      ],
      "bbox_max": [
        1120.0,
        2358.044677734375,
        106.22245788574219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1120.0,
        2331.0,
        105.0
      ],
      "bbox_max": [
        1120.0,
        2350.0,
        107.38323974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        1120.0,
        2350.0,
        105.0
      ],
      "bbox_max": [
        1180.0,
        2400.0,
        116.32262420654297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -2357.0,
      "bbox_min": [
        1171.0,
        2357.0,
        105.0
      ],
      "bbox_max": [
        1180.0,
        2357.0,
        116.32262420654297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2300.0,
      "bbox_min": [
        1070.0,
        2260.0,
        84.70587921142578
      ],
      "bbox_max": [
        1180.0,
        2300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1070.0,
        2260.0,
        93.0434799194336
      ],
      "bbox_max": [
        1180.0,
        2300.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -2279.999755859375,
      "bbox_min": [
        1120.0,
        2280.0,
        93.0434799194336
      ],
      "bbox_max": [
        1180.0,
        2300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277936935425,
        -0.0,
        0.9486833810806274
      ],
      "plane_d": -449.04345703125,
      "bbox_min": [
        1120.0,
        2280.0,
        93.0434799194336
      ],
      "bbox_max": [
        1140.8695068359375,
        2300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1900.0,
      "bbox_min": [
        1180.0,
        1900.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1579904556274414,
        0.0,
        0.9874407052993774
      ],
      "plane_d": 90.84447479248047,
      "bbox_min": [
        1180.0,
        1900.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -1030.380126953125,
      "bbox_min": [
        1180.0,
        2104.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        2331.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2104.0,
      "bbox_min": [
        1187.5,
        2104.0,
        98.0
      ],
      "bbox_max": [
        1190.0,
        2104.0,
        98.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2331.0,
      "bbox_min": [
        1180.0,
        2260.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        2331.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2280.0,
      "bbox_min": [
        1187.5,
        2260.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        2280.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2260.0,
      "bbox_min": [
        1187.5,
        2260.0,
        98.0
      ],
      "bbox_max": [
        1190.0,
        2260.0,
        98.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1180.0,
        1900.0,
        96.80000305175781
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2331.0,
      "bbox_min": [
        1180.0,
        2104.0,
        96.80000305175781
      ],
      "bbox_max": [
        1200.0,
        2400.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        1180.0,
        2400.0,
        96.80000305175781
      ],
      "bbox_max": [
        1200.0,
        2400.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2280.0,
      "bbox_min": [
        1183.0001220703125,
        2104.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        2280.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -1030.380126953125,
      "bbox_min": [
        1183.0001220703125,
        2104.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        2260.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2104.0,
      "bbox_min": [
        1183.0001220703125,
        2104.0,
        98.0
      ],
      "bbox_max": [
        1190.0,
        2104.0,
        98.82351684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.49613896012306213,
        0.8682432174682617
      ],
      "plane_d": 1034.44970703125,
      "bbox_min": [
        1183.0001220703125,
        2257.199951171875,
        98.0
      ],
      "bbox_max": [
        1200.0,
        2260.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2260.0,
      "bbox_min": [
        1183.0001220703125,
        2260.0,
        98.0
      ],
      "bbox_max": [
        1190.0,
        2260.0,
        98.82351684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4138029217720032,
        0.9103664755821228
      ],
      "plane_d": -953.4019165039062,
      "bbox_min": [
        1180.0,
        1910.0,
        97.64704895019531
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1180.0,
        1910.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        2040.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2331.0,
      "bbox_min": [
        1180.0,
        2084.0,
        97.64704895019531
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -104.99999237060547,
      "bbox_min": [
        1180.0,
        2331.0,
        97.64704895019531
      ],
      "bbox_max": [
        1200.0,
        2420.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -2350.0,
      "bbox_min": [
        1180.0,
        2350.0,
        97.64704895019531
      ],
      "bbox_max": [
        1200.0,
        2400.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        1180.0,
        2400.0,
        97.64704895019531
      ],
      "bbox_max": [
        1200.0,
        2400.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1180.0,
        2331.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        2350.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1180.0,
        2084.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        2280.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2280.0,
      "bbox_min": [
        1180.0,
        2104.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        2280.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -1030.380126953125,
      "bbox_min": [
        1180.0,
        2104.0,
        98.0
      ],
      "bbox_max": [
        1200.0,
        2260.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2104.0,
      "bbox_min": [
        1180.0,
        2104.0,
        98.0
      ],
      "bbox_max": [
        1190.0,
        2104.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.49613896012306213,
        0.8682432174682617
      ],
      "plane_d": 1034.44970703125,
      "bbox_min": [
        1180.0,
        2257.941162109375,
        98.0
      ],
      "bbox_max": [
        1200.0,
        2260.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2260.0,
      "bbox_min": [
        1180.0,
        2260.0,
        98.0
      ],
      "bbox_max": [
        1190.0,
        2260.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        980.0,
        1830.0,
        79.9999771118164
      ],
      "bbox_max": [
        1070.0,
        2331.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1900.0,
      "bbox_min": [
        1030.0,
        1900.0,
        80.0
      ],
      "bbox_max": [
        1070.0,
        2331.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1900.0,
        80.0
      ],
      "bbox_max": [
        1070.0,
        2331.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        1030.0,
        1950.0,
        80.0
      ],
      "bbox_max": [
        1070.0,
        2331.0,
        84.70587921142578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2300.0,
      "bbox_min": [
        1061.3636474609375,
        2300.0,
        80.0
      ],
      "bbox_max": [
        1070.0,
        2331.0,
        84.70587921142578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024992192164063454,
        -0.999687671661377,
        0.0
      ],
      "plane_d": 2158.57568359375,
      "bbox_min": [
        1030.0,
        1930.0,
        80.0
      ],
      "bbox_max": [
        1070.0,
        2331.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2331.0,
      "bbox_min": [
        1050.5,
        2260.0,
        83.6898422241211
      ],
      "bbox_max": [
        1070.0,
        2331.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1050.5,
        2260.0,
        83.6898422241211
      ],
      "bbox_max": [
        1070.0,
        2300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -2300.0,
      "bbox_min": [
        1061.3636474609375,
        2300.0,
        83.6898422241211
      ],
      "bbox_max": [
        1070.0,
        2300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        1030.0,
        1930.0,
        80.0
      ],
      "bbox_max": [
        1070.0,
        1950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1040.0,
        1930.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1950.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1870.0,
        79.9999771118164
      ],
      "bbox_max": [
        1030.0,
        2185.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2185.0,
      "bbox_min": [
        980.0,
        1904.199951171875,
        98.0
      ],
      "bbox_max": [
        1030.0,
        2185.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1009.9999389648438,
      "bbox_min": [
        1010.0,
        2177.800048828125,
        98.0
      ],
      "bbox_max": [
        1010.0,
        2182.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4657464623451233,
        0.8849182724952698
      ],
      "plane_d": 800.1524047851562,
      "bbox_min": [
        980.0,
        1904.199951171875,
        98.0
      ],
      "bbox_max": [
        990.0,
        1908.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        990.0,
        1904.199951171875,
        98.0
      ],
      "bbox_max": [
        990.0,
        1908.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2185.0,
      "bbox_min": [
        980.0,
        1870.0,
        79.9999771118164
      ],
      "bbox_max": [
        1030.0,
        2185.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4299336075782776,
        0.9028605818748474
      ],
      "plane_d": 847.8291015625,
      "bbox_min": [
        980.0,
        1870.0,
        79.9999771118164
      ],
      "bbox_max": [
        1020.0,
        2182.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1009.9999389648438,
      "bbox_min": [
        1010.0,
        2140.0,
        79.9999771118164
      ],
      "bbox_max": [
        1010.0,
        2182.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        990.0,
        1870.0,
        80.0
      ],
      "bbox_max": [
        990.0,
        1908.0,
        98.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}